import React, { useState, useEffect, useContext, useRef } from 'react';
import packageJson from '../package.json';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import { useUserAPI } from './components/useUserAPI';
import DeviceContext from './components/DeviceContext';
// import UAParser from 'ua-parser-js';
import { PolicyCheck } from './pages/home/PolicyCheck'
import { Home } from './pages/home/Home'
import { Intro } from './pages/intro/Intro'
import { Attention } from './pages/shopping/Attention'
import { Shopping } from './pages/shopping/Shopping'
import { Modal } from './components/Modal'
import { PayModal } from './components/PayModal'
import { NoBarcode } from './pages/shopping/NoBarcode'
import { ItemNum } from './pages/shopping/ItemNum'
import { ItemDelete } from './pages/shopping/ItemDelete'
import { GetAttention } from './pages/shopping/GetAttention'
import BarcodeScanner from './pages/scan/BarcodeScanner'
import QRScanner from './pages/scan/QRScanner'
// import { RegiSelect } from './pages/regi/RegiSelect'
import { FrontCheck } from './pages/regi/FrontCheck'
import { RegiSenyou } from './pages/regi/RegiSenyou'
import { RegiSenyouComp } from './pages/regi/RegiSenyouComp'
import { RegiSelf } from './pages/regi/RegiSelf'
import { RegiSelfComp } from './pages/regi/RegiSelfComp'
import { RegiYujin } from './pages/regi/RegiYujin'
import { RegiMeisai } from './pages/regi/RegiMeisai'
import { Faq } from './pages/other/Faq'
import { Policy } from './pages/other/Policy'
import { Help } from './pages/other/Help'
import { KujiLottery } from './pages/kuji/KujiLottery'
import { KujiList } from './pages/kuji/KujiList'
import { SharedInfoContext } from './components/SharedInfoContextProvider';
import { Error32 } from './components/Error32';
import { Error35 } from './components/Error35';
import { ErrorVersion } from './components/ErrorVersion';

import { GPSStorelist } from './components/GPSStorelist';
import { ShoppingStart } from './components/ShoppingStart';
// import { iAeonMiniApp } from './library/iaeon_sdk_240405';
// import * as IaeonSdk from './library/iaeon_sdk.js';
import { iAeonInit } from './library/iaeon_sdk.js';
import { iAeonGetMemberInfo } from './library/iaeon_sdk.js';
import { iAeonGetLocation } from './library/iaeon_sdk.js';
import { iAeonGetPointBarCode } from './library/iaeon_sdk.js';
import { iAeonGetAppInfo } from './library/iaeon_sdk.js';
import { iAeonGetData } from './library/iaeon_sdk.js';
import { iAeonSetData } from './library/iaeon_sdk.js';
import { iAeonCheckSilentMode } from './library/iaeon_sdk.js';
import { iAeonOpenBrowser } from './library/iaeon_sdk.js';
import { iAeonGetStoreInfo } from './library/iaeon_sdk.js';
import { useSDK } from "./scandit/sdk";

//お買物API
import { callOkaimonoAPI } from "./components/okaimonoAPI";

import styles from './styles/Home.module.scss'

// import * as SDCCore from "scandit-web-datacapture-core";
// import { barcodeCaptureLoader } from "scandit-web-datacapture-barcode";

import useSound from 'use-sound';
import se_01 from './sound/s01_item_num.mp3';
import se_03 from './sound/s03_item_change.mp3';
import se_07_scan from './sound/s07_scan.mp3';
import se_08 from './sound/s08_se_delay0.mp3';
import se_10 from './sound/s10_item_delete.mp3';

const direction = {
	'policy_check': 'left',
	'home': 'left',
	'intro': 'left',
	'attention': 'left',
	'shopping': 'left',
	'scan': 'left',
	'qrscan': 'left',
	'regi_select': 'left',
	'front_check': 'left',
	'regi_senyou': 'left',
	'regi_senyou_comp': 'left',
	'regi_self': 'left',
	'regi_self_comp': 'left',
	'regi_yujin': 'left',
	'regi_meisai': 'left',
	'kuji_lottery': 'left',
	'kuji_list': 'left',
	'faq': 'left',
	'policy': 'left',
	'help': 'left',
	'error_32': 'left',
	'error_35': 'left',
	'error_version': 'left',
};
const motionConfig = {
	initial: {
		y: 30,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: 30,
		opacity: 0,
	},
};

// let oldConponent = "home";
let oldConponent = "policy_check";
let moveDirection = "move_next";

function App() {
const { loaded, sdk } = useSDK();
const { startSDK } = useSDK();


//----------------------------------------
//ページ遷移x
//----------------------------------------

// const navigate = useNavigate();
// const location = useLocation();
const nodeRef = useRef(null);
const barcodeScannerRef = useRef(null);
const [currentComponent, setCurrentComponent] = useState('');
// const [currentComponent, setCurrentComponent] = useState('home');
// const [currentComponent, setCurrentComponent] = useState('policy_check');
// const pathname = location.pathname;
const timeout = { enter: 300, exit: 300 };
// const getDirection = (currentKey: string) => direction[currentKey as keyof typeof direction] ?? 'left';
const getDirection = (currentKey) => direction[currentKey] ?? 'left';

const getMoveDir = () =>{
	if(oldConponent ==="error_version" && currentComponent !== "error_version"){
		moveDirection = "move_next";
	}else if(oldConponent ==="policy_check" && currentComponent !== "policy_check"){
		moveDirection = "move_next";
	}else if(oldConponent ==="home" && currentComponent !== "policy_check" && currentComponent !== "home"){
			moveDirection = "move_next";
	}else if(oldConponent ==="intro" && currentComponent !== "home" && currentComponent !== "intro"){
		moveDirection = "move_next";
	}else if(oldConponent ==="attention" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention"){
		moveDirection = "move_next";
	}else if(oldConponent ==="shopping" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping"){
		moveDirection = "move_next";
	}else if(oldConponent ==="scan" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "scan"){
		moveDirection = "move_next";
	}else if(oldConponent ==="qrscan" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_select" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select"){
		moveDirection = "move_next";
	}else if(oldConponent ==="front_check" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "front_check"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_senyou" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_senyou"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_senyou_comp" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_senyou" && currentComponent !== "regi_senyou_comp"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_self" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_self_comp" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_self_comp"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_yujin" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin"){
		moveDirection = "move_next";
	}else if(oldConponent ==="kuji_lottery" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_lottery"){
		moveDirection = "move_next";
	}else if(oldConponent ==="kuji_list" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_lottery" && currentComponent !== "kuji_list" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self_comp"){
		moveDirection = "move_next";
	}else if(oldConponent ==="regi_meisai" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_lottery" && currentComponent !== "kuji_list" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self_comp" && currentComponent !== "regi_meisai"){
		moveDirection = "move_next";
	}else if(oldConponent ==="error_35" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin" && currentComponent !== "error_35"){
		moveDirection = "move_next";
	}else if(oldConponent ==="error_32" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "qrscan" && currentComponent !== "regi_select" && currentComponent !== "regi_self" && currentComponent !== "regi_yujin" && currentComponent !== "error_32"){
		moveDirection = "move_next";
	}else if(oldConponent ==="faq" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "regi_senyou" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self" && currentComponent !== "regi_self_comp" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_list" && currentComponent !== "faq"){
		moveDirection = "move_next";
	}else if(oldConponent ==="policy" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "regi_senyou" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self" && currentComponent !== "regi_self_comp" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_list" && currentComponent !== "policy"){
		moveDirection = "move_next";
	// }else if(oldConponent ==="help" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "regi_senyou" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self" && currentComponent !== "regi_self_comp" && currentComponent !== "help"){
	}else if(oldConponent ==="help" && currentComponent !== "home" && currentComponent !== "intro" && currentComponent !== "attention" && currentComponent !== "shopping" && currentComponent !== "regi_senyou" && currentComponent !== "regi_senyou_comp" && currentComponent !== "regi_self" && currentComponent !== "regi_self_comp" && currentComponent !== "regi_yujin" && currentComponent !== "kuji_list" && currentComponent !== "help"){
		moveDirection = "move_next";
	}else{
		moveDirection = "move_back";
	}
	// console.log("oldConponent: "+ oldConponent);
	// console.log("currentComponent: "+ currentComponent);
	// console.log("moveDirection: "+ moveDirection);
	// oldConponent = currentComponent;
	return moveDirection;
}

const setOldComponent = () => {
	oldConponent = currentComponent;
}


//----------------------------------------
// useState
//----------------------------------------

const { os, browser, device } = useContext(DeviceContext);

const [page, setPage] = useState("");
// const [page, setPage] = useState("home");
// const [page, setPage] = useState("policy_check");

// const [showModal, setShowModal] = useState(false)
// const [errNum, setErrNum] = useState("")
// const [errTxt, setErrTxt] = useState("")
// const [err, setErr] = useState([true,"ERR001xx","i1b0;お支払いコード読み取りエラー;お支払いコードの読み取りができませんでした。もう一度スキャンして頂くか、お近くの従業員にお声がけください。[34];Payment code reading error.;The payment code could not be read. Please scan the code again or call nearby staff for assistance.[34]"])
const [errFlg, setErrFlg] = useState(false)
const [err, setErr] = useState([])

const [delModal, setDelModal] = useState([])
const [showPayModal, setShowPayModal] = useState(false)
const [item, setItem] = useState(0)
const [gnav, setGnav] = useState(false)
const [showBarcodeScan, setBarcodeScan] = useState(false)
// const [scanFirst, setScanFirst] = useState(true);
// const [scanFirstStart, setScanFirstStart] = useState(false);
const [scanFlg, setScanFlg] = useState(false);
const [paycheckQR, setPaycheckQR] = useState()
const [shoppingStData, setShoppingStData] = useState()
const [kujiResult, setKujiResult] = useState([])
const [prizeList, setPrizeList] = useState()
const [keypluFlg, setKeypluFlg] = useState(false)
const [activeStore, setActiveStore] = useState()
const [closeStore, setCloseStore] = useState([])
//タイムアウト回数：-1はタイムアウトなし、0はカウント開始、3になったらエラー35
const [timeoutCountFlg, setTimeoutCountFlg] = useState(false)
const [timeoutCount, setTimeoutCount] = useState(0)
const [settlecheckFlg, setSettlecheckFlg] = useState(false)
const [keypluCount, setKeypluCount] = useState(0);
const [regiType, setRegiType] = useState();
const [recoveryChoice, setRecoveryChoice] = useState();
const [soundState, setSoundState] = useState()
const [scanActive, setScanActive] = useState("")
const [osinfo, setOsinfo] = useState()
const [appHeight, setAppHeight] = useState("")
const [home_realheight, setHome_realheight] = useState()
const [home_nHeight, setHome_nHeight] = useState()

//初回カメラ起動
const [cameraFirst, setCameraFirst] = useState(true);

//ボーナス、くじバナーアクティブ番号
const [activeBnSlide, setActiveBnSlide] = useState(0);

//SDK開始フラグ（true で startSDK（SDK開始
const [sdkStartFlg, setSdkStartFlg] = useState(false);
const [sdkStartFirst, setSdkStartFirst] = useState(true);
//くじ・ボーナスアテンション
const [getAtState, setGetAtState] = useState([]);
//ボーナスアテンション用ボーナス金額
const [bonusAmount, setBonusAmount] = useState(0);
//くじアテンション用くじ回数
const [lotteryTimes, setLotteryTimes] = useState(0);
//くじ・ボーナスアテンション用 個数変更フラグ
const [getAtChange, setGetAtChange] = useState(false);
//せき止め再確認フラグ
const [frontCheckRetry, setFrontCheckRetry] = useState(false);
//URLパラメータ指定店舗（お気に入り店舗
const [ paramStore, setParamStore ] = useState();
//URLパラメータ指定店舗住所（お気に入り店舗住所
const [ paramStoreAddress, setParamStoreAddress ] = useState();
//近くの店舗住所
const [ storeAddressArr, setStoreAddressArr ] = useState([]);
//位置情報取得動作開始
const [posFlg, setPosFlg] = useState(false);
//OTB Code
const [otb, setOtb] = useState("");
// OTB取得中フラグ
const [isFetchingOtb, setIsFetchingOtb] = useState(false);
//OTB エラーフラグ（true:OTB取得失敗 false:通常 OTB取得成功
const [otbErr, setOtbErr] = useState(false);
//OTB エラーモーダル表示状態（true:OTBエラーモーダル表示済 false:OTBエラーモーダル未表示
const [otbErrDispState, setOtbErrDispState] = useState(false);

useEffect(() => {
	console.log("window.innerWidth: " + window.innerWidth);
	console.log("----------------------------");
	console.log("【page change】"+page);
	setCurrentComponent(page);
	console.log("oldConponent: "+ oldConponent);
	console.log("currentComponent: "+ currentComponent);
	setOldComponent();
	console.log("----------------------------");
}, [page]);

useEffect(() => {
	console.log(`OkaimonoApp: v${packageJson.version}`);
}, []);

const { userinfoAPI, data: userData, loading: userLoading, error: userError } = useUserAPI();
const { userregisterAPI, data: userregisterData, loading: userregisterLoading, error: userregisterError } = useUserAPI();
//近く対象店舗リストAPI
const { gpsstorelistAPI, data: GPSStorelistData, loading: GPSStorelistLoading, error: GPSStorelistError } = useUserAPI();
//ミニアプリ用近くの店舗API
const { miniappgpsstorelistAPI, data: miniappgpsstorelistData, loading: miniappgpsstorelistLoading, error: miniappgpsstorelistError } = useUserAPI();
//店舗情報取得API（未使用 25.03.26
const { storelistAPI, data: storelistData, loading: storelistLoading, error: storelistError } = useUserAPI();
const [shoppingData, setShoppingData] = useState({});
const { getterminalnumberAPI, data: getterminalnumberData, loading: getterminalnumberLoading, error: getterminalnumberError } = useUserAPI();

//売上一覧：明細用
const [saleData, setSaleData] = useState({});

const sharedInfo = useContext(SharedInfoContext);
const { terminalCode, updateTerminalCode } = useContext(SharedInfoContext);
const { storeCode, updateStoreCode } = useContext(SharedInfoContext);
const { token, updateToken } = useContext(SharedInfoContext);
const { gateFlag, updateGateFlag } = useContext(SharedInfoContext);
const { storeInfo, updateStoreInfo } = useContext(SharedInfoContext);
const { lastTimeStoreCode, updateLastTimeStoreCode } = useContext(SharedInfoContext);
const { glocation, updategLocation } = useContext(SharedInfoContext);
const { favStore, updateFavStore } = useContext(SharedInfoContext);

const [shoppingArr, setShoppingArr] = useState([]);

//スタート画面高さ（一覧なし時に使用
const [homeHeight, setHomeHeight] = useState(800);

//お買物アプリ：買物一覧、スキャン画面 広告表示用
const [adjustedHeight, setAdjustedHeight] = useState();


//----------------------------------------
// iAEON API：0.初期化API
//----------------------------------------

//0.初期化API
function callAPI_1(pastore){
	let successCall_0 = function(success){
		// alert("【iAeonInit】success");
	// console.log("callAPI_0 success："+success);
		// var aaa = JSON.stringify(success);
		var aaa = success;
		console.log('【iAeonInit】success：' + aaa);
		console.log('【iAeonInit】onetime_token：' + aaa.onetime_token);
		//19.データ取得API（ポリシー同意確認
		callAPI_19();
		//19.データ取得API（端末番号確認
		callAPI_19_tcode();
		//4.店舗情報取得API（住所取得
		if(pastore !== null){
			// callAPI_4_paramStore(pastore);
		}
	}
	let errorCall_0 = function(error){
		// alert("【iAeonInit】error: " + error);
	// console.log("callAPI_0 error："+error);
		var bbb = error;
		console.log('【iAeonInit】error: ' + error.error_code + " : " + error.message);
		if(error.error_code === "000073"){ //「エラー73：既に初期化済み」の場合は、スルーして次へ
			//19.データ取得API（ポリシー同意確認
			callAPI_19();
			//19.データ取得API（端末番号確認
			callAPI_19_tcode();
		}else{
			setErrFlg(true);
			var error_msg = ";["+error.error_code+"];"+error.message+";;;";
			setErr([true, error.error_code, error_msg]);
		}
	}
	console.log("----------------------------");
	console.log("【iAeonInit】call");
	iAeonInit({"client_id":"55733068406029262116014198274077"}).then(successCall_0).catch(errorCall_0);
}


//----------------------------------------
// iAEON API：2.会員情報取得API
//----------------------------------------

//2.会員情報取得API
function callAPI_2(tcode){
    let successCall_2 = function(success){
		// alert("【iAeonGetMemberInfo】success");
        // var aaa = JSON.stringify(success);
        var aaa = success;
		console.log('【iAeonGetMemberInfo】success：' + aaa);
		console.log('【iAeonGetMemberInfo】aeon_memberid：' + aaa.aeon_memberid);
		console.log('【iAeonGetMemberInfo】favorite_store：' + aaa.favorite_store);
		console.log('【iAeonGetMemberInfo】favorite_store[0].code：' + aaa.favorite_store[0].code);

		updateTerminalCode(tcode);
		//18.データ保存API（端末番号保存
		callAPI_18(tcode);
		//11.アプリケーション情報取得API
		callAPI_11(tcode);
    }
    let errorCall_2 = function(error){
		// alert("【iAeonGetMemberInfo】error: " + error);
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonGetMemberInfo】error: ' + error.error_code + " : " + error.message);
		setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log("【iAeonGetMemberInfo】call");
    iAeonGetMemberInfo().then(successCall_2).catch(errorCall_2);
}


//----------------------------------------
// iAEON API：11.アプリケーション情報取得API
//----------------------------------------

const { appInfo, updateAppInfo } = useContext(SharedInfoContext);
const { aeonPayVerCheck, updateAeonPayVerCheck } = useContext(SharedInfoContext);
const { memberCodeVerCheck, updateMemberCodeVerCheck } = useContext(SharedInfoContext);

//11.アプリケーション情報取得API
function callAPI_11(tcode){
    let successCall_11 = function(success){
		// alert("【iAeonGetAppInfo】success");
        // var aaa = JSON.stringify(success);
        var aaa = success;
		console.log('【iAeonGetAppInfo】success：' + aaa);
		console.log('【iAeonGetAppInfo】app_version：' + aaa.app_version);
		console.log('【iAeonGetAppInfo】app_version miin：' + process.env.REACT_APP_iAEON_VER);
		console.log('【iAeonGetAppInfo】os：' + aaa.os);
		console.log('【iAeonGetAppInfo】os_version：' + aaa.os_version);
		console.log('【iAeonGetAppInfo】os_version min：' + process.env.REACT_APP_iOS_VER);

		if (compareVersions(String(aaa.app_version), "5.1.0") < 0) {
			console.log("【iAeonGetAppInfo】AEON Pay連携確認: 5.1.0より小さい AEON Pay暫定版");
			updateAeonPayVerCheck(false);
		}else {
			console.log("【iAeonGetAppInfo】AEON Pay連携確認: 5.1.0以上 AEON Pay連携版");
			updateAeonPayVerCheck(true);
		}

		if (compareVersions(String(aaa.app_version), "5.4.0") < 0) {
			console.log("【iAeonGetAppInfo】会員コード連携確認: 5.4.0より小さい 会員コード暫定版（STEP1");
			updateMemberCodeVerCheck(false);
		}else {
			console.log("【iAeonGetAppInfo】会員コード連携確認: 5.4.0以上 会員コード連携版（STEP2");
			updateMemberCodeVerCheck(true);
		}

		let appVer = String(process.env.REACT_APP_iAEON_VER);
		if (compareVersions(String(aaa.app_version), appVer) < 0) {
			// console.log("bbbはaaaより大きい");
			console.log("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "より小さい");
			// alert("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "より小さい");

			// if (loaded) {
			// 	sdk.cleanup();
			// }
			updateAppInfo(["iaeon_err",aaa.os]);
			console.log("【iAeonGetAppInfo】iAEON バージョンエラー → エラー画面へ");
			setCurrentComponent("error_version");
			setPage("error_version");
		} else {
			// console.log("aaaとbbbは同じバージョン");
			console.log("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "以上");
			// alert("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "以上");

			if(aaa.os === "ios"){
				// console.log("【iAeonGetAppInfo】os check: ios "+aaa.os_version.substr(".")[0]);
				let iosVer = String(process.env.REACT_APP_iOS_VER);
				// if(aaa.os_version.substr(".")[0] < iosVer){
				if (compareVersions(String(aaa.os_version), iosVer) < 0) {
					console.log("【iAeonGetAppInfo】os_version check: " + process.env.REACT_APP_iOS_VER + "より小さい");
					// alert("【iAeonGetAppInfo】os_version check: " + process.env.REACT_APP_iOS_VER + "より小さい");

					// if (loaded) {
					// 	sdk.cleanup();
					// }
					updateAppInfo(["ios_err",aaa.os]);
					console.log("【iAeonGetAppInfo】iOS バージョンエラー → エラー画面へ");
					setCurrentComponent("error_version");
					setPage("error_version");
				}else{
					console.log("【iAeonGetAppInfo】os_version check: " + process.env.REACT_APP_iOS_VER + "以上");
					// alert("【iAeonGetAppInfo】os_version check: " + process.env.REACT_APP_iOS_VER + "以上");

					//12.位置情報取得API
					//callAPI_12(tcode);

					//userinfoAPI(tcode);

					//scandit SDK 開始
					// if(sdkStartFlg === false){
					// 	setSdkStartFlg(true);
					// }

					//24.サイレントモードチェックAPI：テスト
					// callAPI_24();

					//25.外部ブラウザOpenAPI：テスト
					// callAPI_25('https://www.aeonretail.jp/privacy/');
				}
			}else{
				console.log("【iAeonGetAppInfo】os check: ios以外");

				//12.位置情報取得API
				//callAPI_12(tcode);

				//userinfoAPI(tcode);

				//scandit SDK 開始
				// if(sdkStartFlg === false){
				// 	setSdkStartFlg(true);
				// }
				//24.サイレントモードチェックAPI：テスト
				// callAPI_24();

				//25.外部ブラウザOpenAPI：テスト
				// callAPI_25('https://www.aeonretail.jp/privacy/');
			}
		}
		// if(aaa.app_version < appVer){
		// 	console.log("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "より小さい");
		// 	alert("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "より小さい");
		// }else{
		// 	console.log("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "以上");
		// 	alert("【iAeonGetAppInfo】app_version check: " + process.env.REACT_APP_iAEON_VER + "以上");
		// }
    }
    let errorCall_11 = function(error){
		// alert("【iAeonGetAppInfo】error: " + error);
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonGetAppInfo】error: ' + error.error_code + " : " + error.message);
		setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonGetAppInfo】call');
    iAeonGetAppInfo().then(successCall_11).catch(errorCall_11);
}

//OSバージョン比較
function compareVersions(v1, v2) {
	const v1Parts = v1.split('.').map(Number);
	const v2Parts = v2.split('.').map(Number);

	for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
		const v1Part = v1Parts[i] || 0;
		const v2Part = v2Parts[i] || 0;

		if (v1Part > v2Part) {
			return 1;
		}
		if (v1Part < v2Part) {
			return -1;
		}
	}

	return 0;
}


//----------------------------------------
// iAEON API：12.位置情報取得API
//----------------------------------------

// useEffect(() => {
// 	if(posFlg === true){
// 		//12.位置情報取得API
// 		callAPI_12(sharedInfo.terminalCode);
// 	}
// }, [posFlg]);

//12.位置情報取得API
function callAPI_12(tcode){
	//仮対応
	// let pos = "35.600458, 140.113616";
	// updategLocation(pos);
	// console.log("sharedInfo.terminalCode: " + tcode);
	// userinfoAPI(tcode);

	//本対応
    let successCall_12 = function(success){
		// alert("【iAeonGetLocation】success");
        var aaa = success;
		console.log('【iAeonGetLocation】success：' + aaa);
		console.log('【iAeonGetLocation】latitude：' + aaa.latitude);
		console.log('【iAeonGetLocation】longtitude：' + aaa.longtitude);
		let pos = aaa.latitude + ", " + aaa.longtitude;
		updategLocation(pos);
		console.log("sharedInfo.terminalCode: " + tcode);
		userinfoAPI(tcode);


		//25.外部ブラウザOpenAPI：テスト
		// callAPI_25('https://www.aeonretail.jp/privacy/');

		//11.アプリケーション情報取得API
		// callAPI_11();
		//scandit SDK 開始
		if(sdkStartFlg === false){
			setSdkStartFlg(true);
		}
    }
    let errorCall_12 = function(error){
		// alert("【iAeonGetLocation】error: " + error);
		var bbb = error;
		console.log('【iAeonGetLocation】error: ' + error.error_code + " : " + error.message);
		setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonGetLocation】call');
    iAeonGetLocation().then(successCall_12).catch(errorCall_12);
}


//----------------------------------------
// iAEON API：24.サイレントモードチェックAPI
//----------------------------------------

//24.サイレントモードチェックAPI
function callAPI_24(){
    let successCall_24 = function(success){
		// alert("【iAeonCheckSilentMode】success");
        var aaa = success;
		console.log('【iAeonCheckSilentMode】success：' + aaa);
		console.log('【iAeonCheckSilentMode】is_silent_mode：' + aaa.is_silent_mode);
		// return aaa.is_silent_mode;

		console.log("soundState: ");
		console.log(soundState);

		if(soundState === "se01_item_num"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			if(aaa.is_silent_mode != true){
				se01_item_num();
			}
			setSoundState();
		}else if(soundState === "se03_item_change"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			if(aaa.is_silent_mode != true){
				se03_item_change();
			}
			setSoundState();
		}else if(soundState === "se10_delete"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			if(aaa.is_silent_mode != true){
				se10_delete();
			}
			setSoundState();
		}else if(soundState === "se07_scan"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			if(aaa.is_silent_mode != true){
				se07_scan();
			}
			setSoundState();
		}else if(soundState === "se08_se"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			if(aaa.is_silent_mode != true){
				se08_se();
			}
			setSoundState();
		}
    }
    let errorCall_24 = function(error){
		// alert("【iAeonCheckSilentMode】error: " + error);
		var bbb = error;
		console.log('【iAeonCheckSilentMode】error: ' + error.error_code + " : " + error.message);
		// setErrFlg(true)xxxxxx;
		// var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		// setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonCheckSilentMode】call');
    iAeonCheckSilentMode().then(successCall_24).catch(errorCall_24);
}


//----------------------------------------
// iAEON API：25.外部ブラウザOpenAPI
//----------------------------------------

//25.外部ブラウザOpenAPI
function callAPI_25(surl){
    let successCall_25 = function(success){
		// alert("【iAeonOpenBrowser】success");
        var aaa = success;
		console.log('【iAeonOpenBrowser】success：' + aaa);

    }
    let errorCall_25 = function(error){
		// alert("【iAeonOpenBrowser】error: " + error);
		var bbb = error;
		console.log('【iAeonOpenBrowser】error: ' + error.error_code + " : " + error.message);
		setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonOpenBrowser】call');
    iAeonOpenBrowser({"url":surl}).then(successCall_25).catch(errorCall_25);
}

//4.店舗情報取得API（住所取得
function callAPI_4_paramStore(scode){
	console.log("----------------------------");
	console.log("【iAeonGetStoreInfo】post");
    let successCall_4 = function(success){
		var aaa = success;
		console.log('【iAeonGetStoreInfo】success：' + aaa);
		console.log('【iAeonGetStoreInfo】id：' + aaa.id);
		console.log('【iAeonGetStoreInfo】code：' + aaa.code);
		console.log('【iAeonGetStoreInfo】name：' + aaa.name);
		console.log('【iAeonGetStoreInfo】prefecture：' + aaa.prefecture);
		console.log('【iAeonGetStoreInfo】city：' + aaa.city);
		console.log('【iAeonGetStoreInfo】street：' + aaa.street);

		let saddress = aaa.prefecture + aaa.city + aaa.street;
		setParamStoreAddress(saddress);
		// storelistData.data.storeList[snum].storeAddress = saddress;
		// console.log('【iAeonGetStoreInfo】storelistData.data.storeList['+snum+'].storeAddress：' + storelistData.data.storeList[snum].storeAddress);
		// if(slast === true){ //最後
		// 	setStorelistAddress(true);

		// 	document.querySelectorAll('.loadingBox01').forEach(function(element) {
		// 		element.classList.remove('is_show');
		// 	});
		// 	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
		// 		element.classList.remove('is_show');
		// 	});
		// }

		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
    }
    let errorCall_4 = function(error){
		var bbb = error;
		console.log('【iAeonGetStoreInfo】error：' + bbb.error_code);

		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
    }

	document.querySelectorAll('.loadingBox01').forEach(function(element) {
		element.classList.add('is_show');
	});
	document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
		element.classList.add('is_show');
	});

    iAeonGetStoreInfo({"store_code":scode}).then(successCall_4).catch(errorCall_4);
}


//----------------------------------------
// iAEON API：9.WAON POINTバーコード取得API（動作テスト
//----------------------------------------

//9.WAON POINTバーコード取得API（動作テスト
function callAPI_9(){
    let successCall_9 = function(success){
        // var aaa = JSON.stringify(success);
        var aaa = success;
		console.log('【iAeonGetPointBarCode】success：' + aaa);
		console.log('【iAeonGetPointBarCode】code：' + aaa.code);
    }
    let errorCall_9 = function(error){
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonGetPointBarCode】error: ' + error.error_code + " : " + error.message);
		setErrFlg(true);
		var error_msg = ";["+error.error_code+"];"+error.message+";;;";
		setErr([true, error.error_code, error_msg]);
    }
	console.log("----------------------------");
	console.log('【iAeonGetPointBarCode】call');
    iAeonGetPointBarCode().then(successCall_9).catch(errorCall_9);
}

//17.決済用バーコード取得API（決済API、決済予約APIで使用
// function callAPI_17(){
//     let successCall_17 = function(success){
//         // var aaa = JSON.stringify(success);
//         var aaa = success;
// 		console.log('【iAeonGetPayBarCode】success：' + aaa);
// 		console.log('【iAeonGetPayBarCode】code：' + aaa.code);
// 		updateOtbCode(aaa.code);
//     }
//     let errorCall_17 = function(error){
//         // var bbb = JSON.stringify(error);
// 		var bbb = error;
// 		console.log('【iAeonGetPayBarCode】error: ' + error.error_code + " : " + error.message);
// 		// setErrFlg(true);
// 		// var error_msg = ";["+error.error_code+"];"+error.message+";;;";
// 		// setErr([true, error.error_code, error_msg]);
//     }
	// console.log("----------------------------");
	// console.log('【iAeonGetPayBarCode】call');
//     iAeonGetPayBarCode().then(successCall_17).catch(errorCall_17);
// }


//----------------------------------------
// iAEON API：19.データ取得API（ポリシー同意確認
//----------------------------------------

//19.データ取得API（ポリシー同意確認
function callAPI_19(){
    let successCall_19 = function(success){
        var aaa = JSON.stringify(success);
		// var jsonString = success.replace(/"}$/, '"}}');
		// var aaa = JSON.perse(jsonString);
		console.log('【iAeonGetData:policy_data】success：' + aaa);
        var bbb = JSON.parse(aaa);
		console.log('【iAeonGetData:policy_data】bbb：');
		console.log(bbb);
        var ccc = JSON.parse(bbb.value);
		console.log('【iAeonGetData:policy_data】value：' + ccc);
		console.log(ccc);
		if(ccc === "true" || ccc === true){
			console.log("【iAeonGetData:policy_data】ポリシー同意あり → ホーム同意画面へ");
			setCurrentComponent("home");
			setPage("home");
		}else{
			console.log("【iAeonGetData:policy_data】ポリシー同意なし → ポリシー同意画面へ");
			setCurrentComponent("policy_check");
			setPage("policy_check");
		}
    }
    let errorCall_19 = function(error){
        // var bbb = JSON.stringify(error);
		// var bbb = error;
		console.log('【iAeonGetData:policy_data】error：: ' + error.error_code + " : " + error.message);
		console.log("【iAeonGetData:policy_data】ポリシー同意なし → ポリシー同意画面へ");

		setCurrentComponent("policy_check");
		setPage("policy_check");
    }
	console.log("----------------------------");
	console.log("【iAeonGetData】call");
    iAeonGetData({"key": "policy_data"}).then(successCall_19).catch(errorCall_19);
}


//----------------------------------------
// iAEON API：19.データ取得API（端末番号確認
//----------------------------------------

//19.データ取得API（端末番号確認
function callAPI_19_tcode(){
    let successCall_19 = function(success){
        var aaat = JSON.stringify(success);
		// var jsonString = success.replace(/"}$/, '"}}');
		// var aaa = JSON.perse(jsonString);
		console.log('【iAeonGetData:tcode】success：' + aaat);
        var bbbt = JSON.parse(aaat);
		console.log('【iAeonGetData:tcode】bbb：');
		console.log(bbbt);
        // var ccct = JSON.parse(bbbt.value);
        var ccct = bbbt.value;
		console.log('【iAeonGetData:tcode】value：' + ccct);
		console.log(ccct);
		console.log("【iAeonGetData:tcode】端末番号保存あり → 会員情報取得APIへ");
		//2.会員情報取得API
		// callAPI_2(ccct);

		updateTerminalCode(ccct);
		//18.データ保存API（端末番号保存
		callAPI_18(ccct);
		//11.アプリケーション情報取得API
		callAPI_11(ccct);
    }
    let errorCall_19 = function(error){
        // var bbb = JSON.stringify(error);
		// var bbb = error;
		console.log('【iAeonGetData:tcode】error：: ' + error.error_code + " : " + error.message);
		console.log("【iAeonGetData:tcode】端末番号保存なし → 端末番号取得へ");
		//端末番号発行API
		getterminalnumberAPI();
    }
	console.log("----------------------------");
	console.log("【iAeonGetData】call");
    iAeonGetData({"key": "tcode"}).then(successCall_19).catch(errorCall_19);
}


//----------------------------------------
// iAEON API：18.データ保存API（端末番号保存
//----------------------------------------

//18.データ保存API（端末番号保存
function callAPI_18(tcode){
	console.log("----------------------------");
	console.log("【iAeonSetData:tcode】post");
    let successCall_18 = function(success){
        // var aaa = JSON.stringify(success);
        // console.log('successCall：' + aaa);
		var aaa = success;
		console.log('【iAeonSetData:tcode】success：' + aaa);
    }
    let errorCall_18 = function(error){
        // var bbb = JSON.stringify(error);
		var bbb = error;
		console.log('【iAeonSetData:tcode】error：' + bbb.error_code);
		if(bbb.error_code === "000068"){
			iAeonSetData({"mode":"put", "key": "tcode", "value": tcode}).then(successCall_18).catch(errorCall_18);
		}
    }
    iAeonSetData({"mode":"add", "key": "tcode", "value": tcode}).then(successCall_18).catch(errorCall_18);
}


//----------------------------------------
//初期化
//----------------------------------------

useEffect(() => {
	// 現在のURLを取得
	var url = new URL(window.location.href);
	console.log("url: " + window.location.href);

	if (!url.searchParams.has('time')) { //URLパラメータ：timeなし
		// 現在のタイムスタンプを取得
		var timestamp = Date.now();

		const domain = window.location.host;
		const queryString = String(window.location.href).split('?')[1] || '';
		// 新しいURLにリダイレクト
		if(domain === "miniapp.irs-test.jp"){
			console.log("domain check: dev");
			// window.location.href = "https://navy:1030003@miniapp.irs-test.jp/?" + queryString + "&time=" + timestamp;
			window.location.href = "https://miniapp.irs-test.jp/?" + queryString + "&time=" + timestamp;
		}else{
			console.log("domain check: other");
			url.searchParams.set('time', timestamp);
			window.location.href = url.href;
		}
	}else{ //URLパラメータ：timeあり
		const spHeight = window.innerHeight;
		document.documentElement.style.setProperty("--vh", spHeight / 100 + "px");


		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		const pStore = urlParams.get('store_code');
		// const pStore = window.location.search.split("?store_code=")[1];
		console.log("paramStore: "+pStore);
		setParamStore(pStore);

		if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
			console.log("REACT_APP_OKAIMONO_FLG: " + process.env.REACT_APP_OKAIMONO_FLG);
			console.log("OKAIMONO 有効");
			//0.初期化API
			// callAPI_1(pStore);

			//19.データ取得API（ポリシー同意確認
			// callAPI_19();

			//お買物API：データ取得API（ポリシー同意確認 << 19.データ取得API（ポリシー同意確認
			okaimonoAPI_checkPolicy().then(() => {
				//19.データ取得API（端末番号確認
				// callAPI_19_tcode();
				//お買物API：データ取得API（端末番号確認 << 19.データ取得API（端末番号確認
				okaimonoAPI_checkTcode();
			});

			//4.店舗情報取得API（住所取得
			// if(pastore !== null){
			// 	callAPI_4_paramStore(pastore);
			// }

		}else if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
			console.log("REACT_APP_IAEON_FLG: " + process.env.REACT_APP_IAEON_FLG);
			console.log("iAEON 有効");
			//0.初期化API
			callAPI_1(pStore);

		}else{ //iAEON無効

			console.log("iAEON 無効");
			const timestamp = Date.now();
			const tccode = "test" + timestamp;
			// const tccode = "testtesttest";
			updateTerminalCode(tccode);
			userinfoAPI(tccode);
			//scandit SDK 開始
			if(sdkStartFlg === false){
				setSdkStartFlg(true);
			}
			//ポリシー同意確認用
			// setCurrentComponent("policy_check");
			// setPage("policy_check");

			setCurrentComponent("home");
			setPage("home");
		}
		// iOS判定
		// const ios = /iPhone|iPad|iPod/i.test(navigator.userAgent);
		// if (ios) { // iOS
		// 	if(window.innerWidth > 320){
		// 		document.querySelector("[name=viewport]").setAttribute('content','width=device-width, user-scalable=no');
		// 	}else{
		// 		document.querySelector("[name=viewport]").setAttribute('content','width=390, user-scalable=no');
		// 	}
		// }else { // Android
			if(window.innerWidth >= 320){
				document.querySelector("[name=viewport]").setAttribute('content','width=device-width, user-scalable=no');
			}else{
				document.querySelector("[name=viewport]").setAttribute('content','width=320, user-scalable=no');
			}
		// }

		//フォアグラウンド時に音声再生を再開
		// const audioContext = new (window.AudioContext || window.webkitAudioContext)();

		// document.addEventListener("visibilitychange", () => {
		// 	console.log("document.visibilityState: ");
		// 	console.log(document.visibilityState);
		// 	console.log("audioContext.state: ");
		// 	console.log(audioContext.state);
		// 	if (document.visibilityState === "visible") {
		// 		console.log("audioContext: resume()");
		// 		audioContext.resume().then(() => {
		// 			console.log("audioContext resumed on user interaction.");
		// 			console.log("audioContext.state: ");
		// 			console.log(audioContext.state);
		// 		}).catch((e) => {
		// 			console.error("Failed to resume the audio context on user interaction:", e);
		// 			console.log("audioContext.state: ");
		// 			console.log(audioContext.state);
		// 		});
		// 	}
		// });
	}

}, []);


//----------------------------------------
//フォアグラウンド時に音声再生を再開
//----------------------------------------

const audioContext = useRef(null);

useEffect(() => {
	if (!audioContext.current) {
		audioContext.current = new (window.AudioContext || window.webkitAudioContext)();
	}

	const handleVisibilityChange = () => {
		if (document.visibilityState === "visible" && audioContext.current?.state === "suspended") {
			audioContext.current.resume()
				.then(() => console.log("audioContext resumed"))
				.catch((e) => console.error("audioContext resume failed:", e));
		}
	};

	document.addEventListener("visibilitychange", handleVisibilityChange);
	return () => {
		document.removeEventListener("visibilitychange", handleVisibilityChange);
	};
}, []);


//----------------------------------------
//scandit SDK
//----------------------------------------

useEffect(() => {
	if(startSDK){
		if(sdkStartFlg === true && sdkStartFirst === true){
			console.log("startSDK");
			setSdkStartFirst(false);
			startSDK();
		}
	}
}, [sdk,startSDK,sdkStartFlg]);

// useEffect(() => {
// 	if(loaded){
// 		if(sdkStartFlg === true){
// 			(async () => {
// 				await sdk.enableCamera(true);
// 			})();
// 		}
// 	}
// }, [loaded,sdkStartFlg]);


//----------------------------------------
//ユーザー情報取得API：レスポンス
//----------------------------------------

useEffect(() => {
	if (userData) {
		if (userData.data) { //SUCCESS
			console.log(`【userinfoAPI】 userinfoFlag: ${userData.data.userinfoFlag}`);
			console.log(`【userinfoAPI】 lastTimeStoreCode: ${userData.data.lastTimeStoreCode}`);

			updateLastTimeStoreCode(userData.data.lastTimeStoreCode);

			if(`${userData.data.userinfoFlag}` === 1){
				let location = "";
				if(process.env.REACT_APP_GPS === "true"){ //iAEON GPS有効
					console.log("iAEON GPS有効");
					location = sharedInfo.glocation;

				}else{ //iAEON GPS無効
					//幕張ベイパーク 0000050570
					// location = "35.646513, 140.049143";
					//イオンスタイル幕張新都心フードストア 0000082900
					// location = "35.656429, 140.027035";
					//イオンスタイル千葉みなと 0000052160
					location = "35.600458, 140.113616";
					//イオン東雲店 0000031200
					// location = "35.648562, 139.802152";
					//イオン大日 0000072700
					// location = "34.749439, 135.580529";
				}

				//24.09.05
				miniappgpsstorelistAPI(location);

				if(paramStore !== null){
					let favlist = [];
					if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON 有効
						console.log("iAEON 有効");
						// favlist = sharedInfo.favStore;
						// favlist.unshift({"storeCode": sharedInfo.lastTimeStoreCode});
						favlist = [
							{"storeCode": paramStore}
						];

					}else{ //iAEON 無効
						favlist = [
							{"storeCode": paramStore}
							// {"storeCode": sharedInfo.lastTimeStoreCode},
							// {"storeCode": "0000082900"},
							// {"storeCode": "0000052160"},
							// {"storeCode": "0000050570"},
							// {"storeCode": "0000031200"},
							// {"storeCode": "0000072700"}
						];
					}
					//未使用 25.03.26
					// storelistAPI(location,favlist);
				}
			}else{
				userregisterAPI();
			}
		} else { //ERROR
			console.log('【userinfoAPI】 userinfoFlag: Data property is missing');
		}
	} else {
		console.log('【userinfoAPI】 userinfoFlag: No Data');
	}
	if(userError){
		console.log("userError");
		console.log(userError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(userLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [userData,userLoading,userError]);


//----------------------------------------
//ユーザー情報登録API：レスポンス
//----------------------------------------

useEffect(() => {
	if (userregisterData) {
		console.log(userregisterData);
		if (userregisterData.isSuccess === true) {
			let location = "";
			if(process.env.REACT_APP_GPS === "true"){ //iAEON GPS有効
				console.log("iAEON GPS有効");
				location = sharedInfo.glocation;

			}else{ //iAEON GPS無効
				//幕張ベイパーク 0000050570
				// location = "35.646513, 140.049143";
				//イオンスタイル幕張新都心フードストア 0000082900
				// location = "35.656429, 140.027035";
				//イオンスタイル千葉みなと 0000052160
				location = "35.600458, 140.113616";
				//イオン東雲店 0000031200
				// location = "35.648562, 139.802152";
				//イオン大日 0000072700
				// location = "34.749439, 135.580529";
			}

			//24.09.05
			miniappgpsstorelistAPI(location);

			if(paramStore !== null){
				let favlist = [];
				if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON 有効
					console.log("iAEON 有効");
					// favlist = sharedInfo.favStore;
					// favlist.unshift({"storeCode": sharedInfo.lastTimeStoreCode});
					favlist = [
						{"storeCode": paramStore}
					];

				}else{ //iAEON 無効
					favlist = [
						{"storeCode": paramStore}
						// {"storeCode": sharedInfo.lastTimeStoreCode},
						// {"storeCode": "0000082900"},
						// {"storeCode": "0000052160"},
						// {"storeCode": "0000050570"},
						// {"storeCode": "0000031200"},
						// {"storeCode": "0000072700"}
					];
				}
				//未使用 25.03.26
				// storelistAPI(location,favlist);
			}
		}
	} else {
		console.log('【registerAPI】 userinfoFlag: No Data');
	}
	if(userregisterError){
		console.log("registerError");
		console.log(userregisterError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(userregisterLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [userregisterData,userregisterLoading,userregisterError]);


//----------------------------------------
//近く対象店舗リストAPI：レスポンス
//----------------------------------------

useEffect(() => {
	if(GPSStorelistData){
		if (GPSStorelistData.data) { //SUCCESS
			// console.log(`【GPSStorelistAPI】 storeList[0].storeCode: ${GPSStorelistData.data.storeList[0].storeCode}`);
			// console.log(`【GPSStorelistAPI】 storeList[0].storeName: ${GPSStorelistData.data.storeList[0].storeName}`);
			// console.log(`【GPSStorelistAPI】 storeList[0].gateFlag: ${GPSStorelistData.data.storeList[0].gateFlag}`);
			// const sstore = GPSStorelistData.data.storeList[0].storeCode;
			//イオンスタイル幕張新都心フードストア
			// const sstore = "0000082900";
			// updateStoreCode(sstore);
			// updateGateFlag(GPSStorelistData.data.storeList[0].gateFlag);
			// shoppingStartAPI(sstore);

			//該当店舗抽出
			// const filteredStores = GPSStorelistData.data.storeList.filter(store => store.storeCode === sstore);
			// console.log("該当店舗情報");
			// console.log(filteredStores[0]);
			// updateStoreInfo(filteredStores[0]);

		}else{ //ERROR
			console.log(`【GPSStorelistAPI】 errorCode: ${GPSStorelistData.errorCode}`);
			console.log(`【GPSStorelistAPI】 errorMessage: ${GPSStorelistData.errorMessage}`);
			console.log(`【GPSStorelistAPI】 isSuccess: ${GPSStorelistData.isSuccess}`);

			// setErrNum(`${GPSStorelistData.errorCode}`);
			// setShowModal(true);
			// setErrTxt(`${GPSStorelistData.errorMessage}`);
			setErrFlg(true);
			setErr([true,`${GPSStorelistData.errorCode}`,`${GPSStorelistData.errorMessage}`]);
		}
	}
	if(GPSStorelistError){
		console.log("GPSStorelistError");
		console.log(GPSStorelistError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(GPSStorelistLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [GPSStorelistData,GPSStorelistLoading,GPSStorelistError]);


//----------------------------------------
//ミニアプリ用近くの店舗API：レスポンス
//----------------------------------------

useEffect(() => { //未使用：24.09.05 → 使用：25.03.28
	if(miniappgpsstorelistData){
		if (miniappgpsstorelistData.data) { //SUCCESS
			// console.log(`【miniappgpsstorelistAPI】 storeList[0].storeCode: ${miniappgpsstorelistData.data.storeList[0].storeCode}`);
			// console.log(`【miniappgpsstorelistAPI】 storeList[0].storeName: ${miniappgpsstorelistData.data.storeList[0].storeName}`);
			// console.log(`【miniappgpsstorelistAPI】 storeList[0].gateFlag: ${miniappgpsstorelistData.data.storeList[0].gateFlag}`);
			// const sstore = miniappgpsstorelistData.data.storeList[0].storeCode;
			//イオンスタイル幕張新都心フードストア
			// const sstore = "0000082900";
			// updateStoreCode(sstore);
			// updateGateFlag(GPSStorelistData.data.storeList[0].gateFlag);
			// shoppingStartAPI(sstore);

			//該当店舗抽出
			// const filteredStores = miniappgpsstorelistData.data.storeList.filter(store => store.storeCode === sstore);
			// console.log("該当店舗情報");
			// console.log(filteredStores[0]);
			// updateStoreInfo(filteredStores[0]);

			if(miniappgpsstorelistData.data.storeList.length > 0){
				console.log(`【miniappgpsstorelistAPI】 storeList[0].storeCode: ${miniappgpsstorelistData.data.storeList[0].storeCode}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].storeName: ${miniappgpsstorelistData.data.storeList[0].storeName}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].storeAddress: ${miniappgpsstorelistData.data.storeList[0].storeAddress}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].distance: ${miniappgpsstorelistData.data.storeList[0].distance}`);
				console.log(`【miniappgpsstorelistAPI】 storeList[0].gateFlag: ${miniappgpsstorelistData.data.storeList[0].gateFlag}`);

				if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
					if(miniappgpsstorelistData.data.storeList.length !== 0){
						// callAPI_4_miniappgpsstorelist(0,miniappgpsstorelistData.data.storeList[0].storeCode);
					}
				}
			}

		}else{ //ERROR
			console.log(`【miniappgpsstorelistAPI】 errorCode: ${miniappgpsstorelistData.errorCode}`);
			console.log(`【miniappgpsstorelistAPI】 errorMessage: ${miniappgpsstorelistData.errorMessage}`);
			console.log(`【miniappgpsstorelistAPI】 isSuccess: ${miniappgpsstorelistData.isSuccess}`);

			// setErrNum(`${miniappgpsstorelistData.errorCode}`);
			// setShowModal(true);
			// setErrTxt(`${miniappgpsstorelistData.errorMessage}`);
			setErrFlg(true);
			setErr([true,`${miniappgpsstorelistData.errorCode}`,`${miniappgpsstorelistData.errorMessage}`]);
		}
	}
	if(miniappgpsstorelistError){
		console.log("miniappgpsstorelistError");
		console.log(miniappgpsstorelistError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(miniappgpsstorelistLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [miniappgpsstorelistData,miniappgpsstorelistLoading,miniappgpsstorelistError]);

const [storelistCount, setStorelistCount] = useState(0);

//4.店舗情報取得API（住所取得用 未使用：24.09.05 → 使用：25.03.28
function callAPI_4_miniappgpsstorelist(snum,scode){
	console.log("----------------------------");
	console.log("【iAeonGetStoreInfo_mini】post");
    let successCall_4 = function(success){
		var aaa = success;
		console.log('【iAeonGetStoreInfo_mini】success：' + aaa);
		console.log('【iAeonGetStoreInfo_mini】id：' + aaa.id);
		console.log('【iAeonGetStoreInfo_mini】code：' + aaa.code);
		console.log('【iAeonGetStoreInfo_mini】name：' + aaa.name);
		console.log('【iAeonGetStoreInfo_mini】prefecture：' + aaa.prefecture);
		console.log('【iAeonGetStoreInfo_mini】city：' + aaa.city);
		console.log('【iAeonGetStoreInfo_mini】street：' + aaa.street);

		let saddress = aaa.prefecture + aaa.city + aaa.street;
		miniappgpsstorelistData.data.storeList[snum].storeAddress = saddress;

		console.log('【iAeonGetStoreInfo_mini】newStoreAddressArr['+snum+']：' + saddress);
		setStorelistCount(snum);
		var nnum = snum + 1;
		if(nnum < miniappgpsstorelistData.data.storeList.length){
			callAPI_4_miniappgpsstorelist(nnum,miniappgpsstorelistData.data.storeList[nnum].storeCode);
		}
    }
    let errorCall_4 = function(error){
		var bbb = error;
		console.log('【iAeonGetStoreInfo_mini】error：' + bbb.error_code);

		miniappgpsstorelistData.data.storeList[snum].storeAddress = null;
		// miniappgpsstorelistData.data.storeList[snum].storeAddress = "ダミーテキストダミーテキスト";
		setStorelistCount(snum);
		var nnum = snum + 1;
		if(nnum < miniappgpsstorelistData.data.storeList.length){
			callAPI_4_miniappgpsstorelist(nnum,miniappgpsstorelistData.data.storeList[nnum].storeCode);
		}
    }
    iAeonGetStoreInfo({"store_code":scode}).then(successCall_4).catch(errorCall_4);
}


//----------------------------------------
//店舗情報取得API：レスポンス（未使用 25.03.26
//----------------------------------------

useEffect(() => {
	if(storelistData){
		if (storelistData.data) { //SUCCESS
			// console.log(`【storelistAPI】 storeList[0].storeCode: ${storelistData.data.storeList[0].storeCode}`);
			// console.log(`【storelistAPI】 storeList[0].storeName: ${storelistData.data.storeList[0].storeName}`);
			// console.log(`【storelistAPI】 storeList[0].gateFlag: ${storelistData.data.storeList[0].gateFlag}`);
			// const sstore = storelistData.data.storeList[0].storeCode;
			//イオンスタイル幕張新都心フードストア
			// const sstore = "0000082900";
			// updateStoreCode(sstore);
			// updateGateFlag(storelistData.data.storeList[0].gateFlag);
			// shoppingStartAPI(sstore);

			//該当店舗抽出
			// const filteredStores = storelistData.data.storeList.filter(store => store.storeCode === sstore);
			// console.log("該当店舗情報");
			// console.log(filteredStores[0]);
			// updateStoreInfo(filteredStores[0]);

		}else{ //ERROR
			console.log(`【storelistAPI】 errorCode: ${storelistData.errorCode}`);
			console.log(`【storelistAPI】 errorMessage: ${storelistData.errorMessage}`);
			console.log(`【storelistAPI】 isSuccess: ${storelistData.isSuccess}`);

			// setErrNum(`${storelistData.errorCode}`);
			// setShowModal(true);
			// setErrTxt(`${storelistData.errorMessage}`);
			setErrFlg(true);
			setErr([true,`${storelistData.errorCode}`,`${storelistData.errorMessage}`]);
		}
	}
	if(storelistError){
		console.log("storelistError");
		console.log(storelistError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(storelistLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		// if(page !== "home"){
			document.querySelectorAll('.loadingBox01').forEach(function(element) {
				element.classList.remove('is_show');
			});
			document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
				element.classList.remove('is_show');
			});
		// }
	}
}, [storelistData,storelistLoading,storelistError]);


//----------------------------------------
//端末番号発行API：レスポンス
//----------------------------------------

useEffect(() => {
	if(getterminalnumberData){
		if (getterminalnumberData.data) { //SUCCESS
			console.log(`【getterminalnumberAPI】 terminalCode: ${getterminalnumberData.data.terminalCode}`);

			//2.会員情報取得API
			// callAPI_2(getterminalnumberData.data.terminalCode);

			updateTerminalCode(getterminalnumberData.data.terminalCode);
			//18.データ保存API（端末番号保存
			// callAPI_18(getterminalnumberData.data.terminalCode);
			//お買物API：データ保存API（端末番号保存 << 18.データ保存API（端末番号保存
			okaimonoAPI_saveTcode(getterminalnumberData.data.terminalCode);
			//11.アプリケーション情報取得API
			// callAPI_11(getterminalnumberData.data.terminalCode);
			//お買物API：アプリケーション情報取得API << 11.アプリケーション情報取得API
			okaimonoAPI_getOsVersion();
			//お買物API：アプリバージョン取得API（25.12.06追加
			okaimonoAPI_getAppVersion();

		}else{ //ERROR
			console.log(`【getterminalnumberAPI】 errorCode: ${getterminalnumberData.errorCode}`);
			console.log(`【getterminalnumberAPI】 errorMessage: ${getterminalnumberData.errorMessage}`);
			console.log(`【getterminalnumberAPI】 isSuccess: ${getterminalnumberData.isSuccess}`);

			// setErrNum(`${storelistData.errorCode}`);
			// setShowModal(true);
			// setErrTxt(`${storelistData.errorMessage}`);
			setErrFlg(true);
			setErr([true,`${getterminalnumberData.errorCode}`,`${getterminalnumberData.errorMessage}`]);
		}
	}
	if(getterminalnumberError){
		console.log("getterminalnumberError");
		console.log(getterminalnumberError);
		setErrFlg(true);
		setErr([true, process.env.REACT_APP_ERROR_CODE_000, process.env.REACT_APP_ERROR_MESSAGE_000]);
		// setErr([true,`000`,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(getterminalnumberLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
}, [getterminalnumberData,getterminalnumberLoading,getterminalnumberError]);


//----------------------------------------
//
//----------------------------------------

const [barcode, setBarcode] = useState('');
// const [intervalFlg, setIntervalFlg] = useState(null);

const [showNoBarcode, setShowNoBarcode] = useState(false)

const onNoBarcode = () => {
	setShowNoBarcode(true)
}

const [showItemNum, setShowItemNum] = useState([])

const onItemNum = () => {
	setShowItemNum(true)
}


//----------------------------------------
// お買い物を中止する
//----------------------------------------

const closeApp = () => {
	console.log("page: " + page);
	setErrFlg(true);
	if(shoppingData && shoppingData.data && shoppingData.data.sumItemCount !== 0){
		if(page === "regi_senyou_comp" || page === "regi_self_comp" || page === "regi_yujin" || page === "regi_meisai"){ //支払完了
			console.log("支払完了");
			setErrFlg(true);
			setErr([true,`shopping_cancel03`,`;;;;;`]);
		}else{ //買物データあり
			// console.log("買物データあり");
			// console.log("shoppingData.data.sumItemCount: " + shoppingData.data.sumItemCount);
			// setErrFlg(true);
			// setErr([true,`shopping_cancel02`,`;;;;;`]);
			console.log("買物データあり（空データを保存して終了");
			setErrFlg(true);
			setErr([true,`shopping_cancel04`,`;;;;;`]);
		}
	}else{ //買物データなし、買物0件
		if(page === "home" || page === "intro" || page === "regi_senyou_comp" || page === "regi_self_comp" || page === "regi_yujin" || page === "regi_meisai" || page === "policy_check"){
			console.log("買物開始前");
			console.log("shoppingData.data :" + "nodata");
			setErrFlg(true);
			setErr([true,`shopping_cancel03`,`;;;;;`]);
		}else{
			console.log("買物データなし、買物0件");
			console.log("shoppingData.data :" + "0");
			setErrFlg(true);
			setErr([true,`shopping_cancel`,`;;;;;`]);
		}
	}
	// se08_se();
	setSoundState("se08_se");
}


//----------------------------------------
// ページコンポーネント
//----------------------------------------

const renderComponent = () => {
	switch (currentComponent) {
	case 'intro':
		return <Intro page={page} setPage={setPage} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} closeStore={closeStore} setCloseStore={setCloseStore} activeStore={activeStore} setActiveStore={setActiveStore} recoveryChoice={recoveryChoice} setRecoveryChoice={setRecoveryChoice} shoppingData={shoppingData} setShoppingData={setShoppingData} soundState={soundState} setSoundState={setSoundState} paramStore={paramStore} paramStoreAddress={paramStoreAddress} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition} okaimonoAPI_didNewTransaction={okaimonoAPI_didNewTransaction}/>
	case 'attention':
		return <Attention page={page} setPage={setPage} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'shopping':
		return <Shopping page={page} setPage={setPage} item={item} setItem={setItem} showNoBarcode={showNoBarcode} setShowNoBarcode={setShowNoBarcode} showBarcodeScan={showBarcodeScan} setBarcodeScan={setBarcodeScan} showPayModal={showPayModal} setShowPayModal={setShowPayModal} showItemNum={showItemNum} setShowItemNum={setShowItemNum} delModal={delModal} setDelModal={setDelModal} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} keypluFlg={keypluFlg} soundState={soundState} setSoundState={setSoundState} scanActive={scanActive} setScanActive={setScanActive} shoppingArr={shoppingArr} setShoppingArr={setShoppingArr} appHeight={appHeight} setAppHeight={setAppHeight} cameraFirst={cameraFirst} setCameraFirst={setCameraFirst} activeBnSlide={activeBnSlide} setActiveBnSlide={setActiveBnSlide} sdkStartFlg={sdkStartFlg} setSdkStartFlg={setSdkStartFlg} getAtState={getAtState} setGetAtState={setGetAtState} bonusAmount={bonusAmount} setBonusAmount={setBonusAmount} lotteryTimes={lotteryTimes} setLotteryTimes={setLotteryTimes} getAtChange={getAtChange} setGetAtChange={setGetAtChange} otb={otb} setOtb={setOtb} otbErr={otbErr} setOtbErr={setOtbErr} isFetchingOtb={isFetchingOtb} setIsFetchingOtb={setIsFetchingOtb} isWaitingForOtb={isWaitingForOtb} setIsWaitingForOtb={setIsWaitingForOtb} isButtonDisabled={isButtonDisabled} setIsButtonDisabled={setIsButtonDisabled} isKaikeiButtonDisabled={isKaikeiButtonDisabled} setIsKaikeiButtonDisabled={setIsKaikeiButtonDisabled} isScanButtonDisabled={isScanButtonDisabled} setIsScanButtonDisabled={setIsScanButtonDisabled} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition} adjustedHeight={adjustedHeight} setAdjustedHeight={setAdjustedHeight} isIOS={isIOS} isIphoneHomeButton={isIphoneHomeButton}/>
	case 'scan':
		return <div>
		<BarcodeScanner ref={barcodeScannerRef} page={page} setPage={setPage} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition} appVersion={appVersion}/>
		</div>
	case 'qrscan':
		return <div>
		<QRScanner page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} timeoutCountFlg={timeoutCountFlg} setTimeoutCountFlg={setTimeoutCountFlg} timeoutCount={timeoutCount} setTimeoutCount={setTimeoutCount} soundState={soundState} setSoundState={setSoundState} regiType={regiType} setRegiType={setRegiType} setSaleData={setSaleData} appHeight={appHeight} setAppHeight={setAppHeight} otb={otb} setOtb={setOtb} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition} okaimonoAPI_didTransferTransaction={okaimonoAPI_didTransferTransaction}/>
		</div>
	case 'front_check':
		return <FrontCheck page={page} setPage={setPage} shoppingStData={shoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} frontCheckRetry={frontCheckRetry} setFrontCheckRetry={setFrontCheckRetry} appHeight={appHeight} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'regi_senyou':
		return <RegiSenyou page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} setPaycheckQR={setPaycheckQR} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} timeoutCountFlg={timeoutCountFlg} setTimeoutCountFlg={setTimeoutCountFlg} timeoutCount={timeoutCount} setTimeoutCount={setTimeoutCount} settlecheckFlg={settlecheckFlg} setSettlecheckFlg={setSettlecheckFlg} soundState={soundState} setSoundState={setSoundState} regiType={regiType} setRegiType={setRegiType} appHeight={appHeight} otbErr={otbErr} setOtbErr={setOtbErr} otbErrDispState={otbErrDispState} setOtbErrDispState={setOtbErrDispState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition} setOnSettleCheckSenyou={setOnSettleCheckSenyou} okaimonoAPI_notifyTransactionData={okaimonoAPI_notifyTransactionData}/>
	case 'regi_senyou_comp':
		return <RegiSenyouComp page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} appHeight={appHeight} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'regi_self':
		return <RegiSelf page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} setPaycheckQR={setPaycheckQR} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} timeoutCountFlg={timeoutCountFlg} setTimeoutCountFlg={setTimeoutCountFlg} timeoutCount={timeoutCount} setTimeoutCount={setTimeoutCount} settlecheckFlg={settlecheckFlg} setSettlecheckFlg={setSettlecheckFlg} soundState={soundState} setSoundState={setSoundState} regiType={regiType} setRegiType={setRegiType} appHeight={appHeight} otbErr={otbErr} setOtbErr={setOtbErr} otbErrDispState={otbErrDispState} setOtbErrDispState={setOtbErrDispState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition} setOnSettleCheckSelf={setOnSettleCheckSelf} okaimonoAPI_notifyTransactionData={okaimonoAPI_notifyTransactionData}/>
	case 'regi_self_comp':
		return <RegiSelfComp page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} appHeight={appHeight} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'regi_yujin':
		return <RegiYujin page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} appHeight={appHeight} otbErr={otbErr} setOtbErr={setOtbErr} otbErrDispState={otbErrDispState} setOtbErrDispState={setOtbErrDispState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'regi_meisai':
		return <RegiMeisai page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} appHeight={appHeight} setAppHeight={setAppHeight} saleData={saleData} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'error_32':
		return <Error32 page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'error_35':
		return <Error35 page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} kujiResult={kujiResult} setKujiResult={setKujiResult} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'error_version':
		return <ErrorVersion page={page} setPage={setPage} shoppingStData={shoppingStData} shoppingData={shoppingData} paycheckQR={paycheckQR} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'faq':
		return <Faq page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'policy':
		return <Policy page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'help':
		return <Help page={page} setPage={setPage} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'kuji_lottery':
		return <KujiLottery page={page} setPage={setPage} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} kujiResult={kujiResult} setKujiResult={setKujiResult} prizeList={prizeList} setPrizeList={setPrizeList} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'kuji_list':
		return <KujiList page={page} setPage={setPage} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} kujiResult={kujiResult} setKujiResult={setKujiResult} prizeList={prizeList} setPrizeList={setPrizeList} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} regiType={regiType} setRegiType={setRegiType} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	case 'home':
		return <Home page={page} setPage={setPage} GPSStorelistData={GPSStorelistData} miniappgpsstorelistData={miniappgpsstorelistData} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} closeStore={closeStore} setCloseStore={setCloseStore} activeStore={activeStore} setActiveStore={setActiveStore} shoppingData={shoppingData} setShoppingData={setShoppingData} recoveryChoice={recoveryChoice} setRecoveryChoice={setRecoveryChoice} storelistData={storelistData} userData={userData} osinfo={osinfo} setOsinfo={setOsinfo} home_realheight={home_realheight} setHome_realheight={setHome_realheight} home_nHeight={home_nHeight} setHome_nHeight={setHome_nHeight} soundState={soundState} setSoundState={setSoundState} paramStore={paramStore} paramStoreAddress={paramStoreAddress} storeAddressArr={storeAddressArr} setStoreAddressArr={setStoreAddressArr} storelistCount={storelistCount} sdkStartFlg={sdkStartFlg} setSdkStartFlg={setSdkStartFlg} posFlg={posFlg} setPosFlg={setPosFlg} homeHeight={homeHeight} setHomeHeight={setHomeHeight} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition} okaimonoAPI_didNewTransaction={okaimonoAPI_didNewTransaction}/>
	case 'policy_check':
		return <PolicyCheck page={page} setPage={setPage} GPSStorelistData={GPSStorelistData} miniappgpsstorelistData={miniappgpsstorelistData} shoppingStData={shoppingStData} setShoppingStData={setShoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} closeStore={closeStore} setCloseStore={setCloseStore} activeStore={activeStore} setActiveStore={setActiveStore} shoppingData={shoppingData} setShoppingData={setShoppingData} recoveryChoice={recoveryChoice} setRecoveryChoice={setRecoveryChoice} storelistData={storelistData} userData={userData} osinfo={osinfo} setOsinfo={setOsinfo} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>
	}
};


//----------------------------------------
// ページ遷移
//----------------------------------------

//FAQ
const goFaq = () => {
	setTimeout(function(){
		setPage("faq")
	}, 300);
	setGnav(false);
	document.documentElement.classList.remove('is_fixed');
	document.body.classList.remove('is_fixed');
	document.body.classList.remove('bg_white');
	// se08_se();
	setSoundState("se08_se");
}
//ポリシー
const goPolicy = () => {
	setTimeout(function(){
		setPage("policy")
	}, 300);
	setGnav(false);
	document.documentElement.classList.remove('is_fixed');
	document.body.classList.remove('is_fixed');
	document.body.classList.remove('bg_white');
	// se08_se();
	setSoundState("se08_se");
}

//ヘルプ
const goHelp = () => {
	setTimeout(function(){
		setPage("help")
	}, 300);
	setGnav(false);
	document.documentElement.classList.remove('is_fixed');
	document.body.classList.remove('is_fixed');
	document.body.classList.remove('bg_white');
	// se08_se();
	setSoundState("se08_se");
}

//戻る
const onPageBack = () => {
	setPage(oldConponent)
	// se08_se();
	setSoundState("se08_se");
}
// const goMyTab = () => {
// 	setPage("mytab")
// }

//メニュー開く
const onMenuBtn = () => {
	// e.preventDefault();
	// setGnav(true)
	setGnav(current => !current);
	// document.html.classList.add('my-custom-class');
	if (gnav === true) {
		document.documentElement.classList.remove('is_fixed');
		document.body.classList.remove('is_fixed');

		if(page === "home"){
			//お買物API：画面遷移API（TOP画面
			okaimonoAPI_didScreenTransition("top");
		}else if(page === "intro"){
			//お買物API：画面遷移API（利用方法
			okaimonoAPI_didScreenTransition("how_to_use");
		}else if(page === "shopping"){
			//お買物API：画面遷移API（ホーム画面
			okaimonoAPI_didScreenTransition("home");
		}else if(page === "scan"){
			//お買物API：画面遷移API（スキャン画面
			okaimonoAPI_didScreenTransition("scan_item");
		}else if(page === "qrscan"){
			//お買物API：画面遷移API（支払いコードスキャン画面
			okaimonoAPI_didScreenTransition("scan_payment_code");
		}else if(page === "regi_senyou" || page === "regi_self" || page === "regi_yujin"){
			//お買物API：画面遷移API（支払い画面
			okaimonoAPI_didScreenTransition("wait_payment");
		}else if(page === "regi_senyou_comp" || page === "regi_self_comp"){
			//お買物API：画面遷移API（清算完了画面
			okaimonoAPI_didScreenTransition("complete_payment");
		}
	}else{
		document.documentElement.classList.add('is_fixed');
		document.body.classList.add('is_fixed');

		//お買物API：画面遷移API（メニュー表示
		okaimonoAPI_didScreenTransition("menu");
	}
	// se08_se();
	setSoundState("se08_se");
}

//くじ一覧：閉じる
const closeKujiList = () => {
	// props.setPage("regi_yujin")
	console.log("regiType: " + regiType);
	setPage(regiType);
	// se08_se();
	setSoundState("se08_se");
}


//----------------------------------------
//サウンド
//----------------------------------------

// const [se08_se] = useSound(se_08);
// let [se08_play, { stop: se08_stop }] = useSound(se_08, { key });

const [se07_scan] = useSound(se_07_scan);

const [isPlaying_s08, setIsPlaying_s08] = useState(false);
// const [se08_se, { stop: se08_stop }] = useSound(se_08, {
const [se08_se, se08_item_num_controls] = useSound(se_08, {
	interrupt: false,
    onplay: () => setIsPlaying_s08(true),
    onend: () => setIsPlaying_s08(false),
    onstop: () => setIsPlaying_s08(false),
});


//----------------------------------------
//サウンド有効・無効
//----------------------------------------

const [isPlaying_s01, setIsPlaying_s01] = useState(false);
const [isPlaying_s03, setIsPlaying_s03] = useState(false);
const [isPlaying_s10, setIsPlaying_s10] = useState(false);

const [se01_item_num,se01_item_num_controls] = useSound(se_01, {
	interrupt: true,
    onplay: () => setIsPlaying_s01(true),
    onend: () => setIsPlaying_s01(false),
    onstop: () => setIsPlaying_s01(false),
});
const [se03_item_change,se03_item_change_controls] = useSound(se_03, {
	interrupt: true,
    onplay: () => setIsPlaying_s03(true),
    onend: () => setIsPlaying_s03(false),
    onstop: () => setIsPlaying_s03(false),
});
const [se10_delete,se10_delete_controls] = useSound(se_10, {
	interrupt: true,
    onplay: () => setIsPlaying_s10(true),
    onend: () => setIsPlaying_s10(false),
    onstop: () => setIsPlaying_s10(false),
});

useEffect(() => {
	// if(soundState !== ""){
	// 	se01_item_num_controls.stop();
	// 	se03_item_change_controls.stop();
	// 	se10_delete_controls.stop();
	// }

	if(process.env.REACT_APP_OKAIMONO_FLG === "true"){ //OKAIMONO有効
		//お買物API：サイレントモードチェックAPI << 24.サイレントモードチェックAPI

		if(soundState === "se01_item_num" || soundState === "se03_item_change" || soundState === "se10_delete" || soundState === "se07_scan" || soundState === "se08_se"){
			okaimonoAPI_checkSilentMode();
		}

	}else if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
		//24.サイレントモードチェックAPI
		callAPI_24();

	}else{ //iAEON無効
		console.log("soundState: ");
		console.log(soundState);

		if(soundState === "se01_item_num"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			se01_item_num();
			setSoundState();
		}else if(soundState === "se03_item_change"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			se03_item_change();
			setSoundState();
		}else if(soundState === "se10_delete"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			se10_delete();
			setSoundState();
		}else if(soundState === "se07_scan"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			se07_scan();
			setSoundState();
		}else if(soundState === "se08_se"){
			// if(isPlaying_s08 === true){
			// 	se08_item_num_controls.stop();
			// }
			if(isPlaying_s01 === true){
				se01_item_num_controls.stop();
			}
			if(isPlaying_s03 === true){
				se03_item_change_controls.stop();
			}
			if(isPlaying_s10 === true){
				se10_delete_controls.stop();
			}
			se08_se();
			setSoundState();
		}
	}
}, [soundState]);


//----------------------------------------
//ボタン抑制
//----------------------------------------

//「スキャン」ボタン有効・無効 true：無効 false：有効
const [isScanButtonDisabled, setIsScanButtonDisabled] = useState(false);
//「お会計」ボタン有効・無効 true：無効 false：有効
const [isKaikeiButtonDisabled, setIsKaikeiButtonDisabled] = useState(false);
//「お支払いへ進む」ボタンがクリックされたか
const [isWaitingForOtb, setIsWaitingForOtb] = useState(false);
//「お支払いへ進む」ボタンの連打防止フラグ
const [isButtonDisabled, setIsButtonDisabled] = useState(false);


//----------------------------------------
//お買物API：ミニアプリから呼び出し MiniApp → Native
//----------------------------------------

const handleClick = async () => {
	try {
		const { callbackId, result } = await callOkaimonoAPI('getDeviceLocation');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("result:", result.result);
			// console.log("緯度:", result.latitude, "経度:", result.longtitude);
			console.log("緯度:", result.latitude, "経度:", result.longitude);
		}else {
			console.log("result:", result.result);
		}
	} catch (error) {
		console.error("APIエラー:", error);
	}
};


//----------------------------------------
//お買物API：データ取得API（ポリシー同意確認 << 19.データ取得API（ポリシー同意確認
//----------------------------------------

const okaimonoAPI_checkPolicy = async () => {
	try {
		console.log("----------------------------");
		console.log("【loadTransactionData:policy_data】お買物API：データ取得API（ポリシー同意確認 call");
		const { callbackId, result } = await callOkaimonoAPI('loadTransactionData', { key: 'policy_data' });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【loadTransactionData:policy_data】success", result);
			console.log("【loadTransactionData:policy_data】result:", result.result);
			console.log("【loadTransactionData:policy_data】value:", result.value);
			console.log("【loadTransactionData:policy_data】ポリシー同意あり → ホーム同意画面へ");

			if(result.value !== "" && result.value !== null && result.value !== undefined && result.value !== "undefined"){
				setCurrentComponent("home");
				setPage("home");
			}else{
				setCurrentComponent("policy_check");
				setPage("policy_check");
			}
		}else {
			console.log("【loadTransactionData:policy_data】error", result);
			console.log("【loadTransactionData:policy_data】result:", result.result);
			console.log("【loadTransactionData:policy_data】ポリシー同意なし → ポリシー同意画面へ");
			setCurrentComponent("policy_check");
			setPage("policy_check");
			//ダミー対応
			// setCurrentComponent("home");
			// setPage("home");
		}

	} catch (error) {
		console.log("【loadTransactionData:policy_data】error", error);
		console.log("【loadTransactionData:policy_data】ポリシー同意なし → ポリシー同意画面へ");
		setCurrentComponent("policy_check");
		setPage("policy_check");
	}
};


//----------------------------------------
//お買物API：データ取得API（端末番号確認 << 19.データ取得API（端末番号確認x
//----------------------------------------

const okaimonoAPI_checkTcode = async () => {
	try {
		console.log("----------------------------");
		console.log("【loadTransactionData:tcode】お買物API：データ取得API（端末番号確認 call");
		const { callbackId, result } = await callOkaimonoAPI('loadTransactionData', { key: 'tcode' });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【loadTransactionData:tcode】success", result);
			console.log("【loadTransactionData:tcode】result:", result.result);
			console.log("【loadTransactionData:tcode】value:", result.value);

			//18.データ保存API（端末番号保存
			// callAPI_18(result.value);
			//11.アプリケーション情報取得API
			// callAPI_11(result.value);

			if(result.value !== "" && result.value !== null && result.value !== undefined && result.value !== "undefined"){
				console.log("【loadTransactionData:tcode】端末番号保存あり → 会員情報取得APIへ");
				//端末番号更新（本番
				updateTerminalCode(result.value);
				//端末番号更新（ダミー
				// updateTerminalCode("123456789");
				//お買物API：データ保存API（端末番号保存 << 18.データ保存API（端末番号保存
				okaimonoAPI_saveTcode(result.value);
				//お買物API：アプリケーション情報取得API << 11.アプリケーション情報取得API
				okaimonoAPI_getOsVersion();
				//お買物API：アプリバージョン取得API（25.12.06追加
				okaimonoAPI_getAppVersion();

				//端末番号保存なし → 端末番号取得へ（ダミー
				// console.log("【loadTransactionData:tcode】端末番号保存なし → 端末番号取得へ");
				//端末番号発行API
				// getterminalnumberAPI();
			}else {
				console.log("【loadTransactionData:tcode】端末番号保存なし → 端末番号取得へ");
				//端末番号発行API
				getterminalnumberAPI();
			}

		}else {
			console.log("【loadTransactionData:tcode】error", result);
			console.log("【loadTransactionData:tcode】result:", result.result);
			console.log("【loadTransactionData:tcode】端末番号保存なし → 端末番号取得へ");
			//端末番号発行API
			getterminalnumberAPI();
		}

	} catch (error) {
		console.log('【loadTransactionData:tcode】error', error);
		console.log("【loadTransactionData:tcode】端末番号保存なし → 端末番号取得へ");
		//端末番号発行API
		getterminalnumberAPI();
	}
};


//----------------------------------------
//お買物API：データ保存API（端末番号保存 << 18.データ保存API（端末番号保存
//----------------------------------------

const okaimonoAPI_saveTcode = async (tcode) => {
	try {
		console.log("----------------------------");
		console.log("【saveTransactionData:tcode】お買物API：データ保存API（端末番号保存 call");
		const { callbackId, result } = await callOkaimonoAPI('saveTransactionData', { key: 'tcode', value: tcode });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【saveTransactionData:tcode】success", result);
			console.log("【saveTransactionData:tcode】result:", result.result);
		}else {
			console.log("【saveTransactionData:tcode】error", result);
			console.log("【saveTransactionData:tcode】result:", result.result);
		}

	} catch (error) {
		console.log('【saveTransactionData:tcode】error', error);
	}
};


//----------------------------------------
//お買物API：アプリケーション情報取得API << 11.アプリケーション情報取得API
//----------------------------------------

//Android8チェックフラグ
const [android8Flg, setAndroid8Flg] = useState(false);

const okaimonoAPI_getOsVersion = async () => {
	try {
		console.log("----------------------------");
		console.log("【getOsVersion】お買物API：アプリケーション情報取得API call");
		const { callbackId, result } = await callOkaimonoAPI('getOsVersion');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【getOsVersion】success", result);
			console.log("【getOsVersion】result:", result.result);
			console.log("【getOsVersion】os:", result.os);
			console.log("【getOsVersion】version:", result.version);

			if(result.os === 1){ //iOS
				// console.log("【iAeonGetAppInfo】os check: ios "+aaa.os_version.substr(".")[0]);
				let iosVer = String(process.env.REACT_APP_iOS_VER);

				if (compareVersions(String(result.version), iosVer) < 0) { //iOSバージョンエラー
					console.log("【getOsVersion】os_version check: " + process.env.REACT_APP_iOS_VER + "より小さい");

					// updateAppInfo(["ios_err",aaa.os]);
					updateAppInfo(["ios_err","ios"]);
					console.log("【getOsVersion】iOS バージョンエラー → エラー画面へ");
					setCurrentComponent("error_version");
					setPage("error_version");

				}else{
					console.log("【getOsVersion】os_version check: " + process.env.REACT_APP_iOS_VER + "以上");
				}

			}else{ //Android
				// console.log("【iAeonGetAppInfo】os check: ios "+aaa.os_version.substr(".")[0]);
				let androidVer = String(process.env.REACT_APP_ANDROID_VER);

				if (compareVersions(String(result.version), androidVer) < 0) { //androidバージョンエラー
					console.log("【getOsVersion】os_version check: " + process.env.REACT_APP_ANDROID_VER + "より小さい");

					// updateAppInfo(["ios_err",aaa.os]);
					updateAppInfo(["android_err","android"]);
					console.log("【getOsVersion】android バージョンエラー → エラー画面へ");
					setCurrentComponent("error_version");
					setPage("error_version");

				}else{
					console.log("【getOsVersion】os_version check: " + process.env.REACT_APP_ANDROID_VER + "以上");
				}

				//Android8チェック
				if (compareVersions(String(result.version), "9.0.0") < 0) { //android8
					console.log("【getOsVersion】android8 check: true");
					setAndroid8Flg(true);
					document.body.classList.add('android8');

				}else { //android8 より大きい
					console.log("【getOsVersion】android8 check: false");
				}

			}

		}else {
			console.log("【getOsVersion】error", result);
			console.log("【getOsVersion】result:", result.result);
			console.log("【getOsVersion】code:", result.error.code);
			console.log("【getOsVersion】message:", result.error.message);
			setErrFlg(true);
			var error_msg = ";["+result.error.code+"];"+result.error.message+";;;";
			setErr([true, result.error.code, error_msg]);
		}

	} catch (error) {
		console.log('【getOsVersion】error', error);
		setErrFlg(true);
		setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
};


//----------------------------------------
//お買物API：サイレントモードチェックAPI << 24.サイレントモードチェックAPI
//----------------------------------------

const okaimonoAPI_checkSilentMode = async () => {
	try {
		console.log("----------------------------");
		console.log("【checkSilentMode】お買物API：サイレントモードチェックAPI call");
		const { callbackId, result } = await callOkaimonoAPI('checkSilentMode');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【checkSilentMode】success", result);
			console.log("【checkSilentMode】result:", result.result);
			console.log("【checkSilentMode】status:", result.status);

			console.log("soundState: ");
			console.log(soundState);

			if(soundState === "se01_item_num"){
				// if(isPlaying_s08 === true){
				// 	se08_item_num_controls.stop();
				// }
				if(isPlaying_s01 === true){
					se01_item_num_controls.stop();
				}
				if(isPlaying_s03 === true){
					se03_item_change_controls.stop();
				}
				if(isPlaying_s10 === true){
					se10_delete_controls.stop();
				}
				if(result.status === "0"){ //サイレントモードOFF
					se01_item_num();
				}
				setSoundState();
			}else if(soundState === "se03_item_change"){
				// if(isPlaying_s08 === true){
				// 	se08_item_num_controls.stop();
				// }
				if(isPlaying_s01 === true){
					se01_item_num_controls.stop();
				}
				if(isPlaying_s03 === true){
					se03_item_change_controls.stop();
				}
				if(isPlaying_s10 === true){
					se10_delete_controls.stop();
				}
				if(result.status === "0"){ //サイレントモードOFF
					se03_item_change();
				}
				setSoundState();
			}else if(soundState === "se10_delete"){
				// if(isPlaying_s08 === true){
				// 	se08_item_num_controls.stop();
				// }
				if(isPlaying_s01 === true){
					se01_item_num_controls.stop();
				}
				if(isPlaying_s03 === true){
					se03_item_change_controls.stop();
				}
				if(isPlaying_s10 === true){
					se10_delete_controls.stop();
				}
				if(result.status === "0"){ //サイレントモードOFF
					se10_delete();
				}
				setSoundState();
			}else if(soundState === "se07_scan"){
				// if(isPlaying_s08 === true){
				// 	se08_item_num_controls.stop();
				// }
				if(isPlaying_s01 === true){
					se01_item_num_controls.stop();
				}
				if(isPlaying_s03 === true){
					se03_item_change_controls.stop();
				}
				if(isPlaying_s10 === true){
					se10_delete_controls.stop();
				}
				if(result.status === "0"){ //サイレントモードOFF
					se07_scan();
				}
				setSoundState();
			}else if(soundState === "se08_se"){
				// if(isPlaying_s08 === true){
				// 	se08_item_num_controls.stop();
				// }
				if(isPlaying_s01 === true){
					se01_item_num_controls.stop();
				}
				if(isPlaying_s03 === true){
					se03_item_change_controls.stop();
				}
				if(isPlaying_s10 === true){
					se10_delete_controls.stop();
				}
				if(result.status === "0"){ //サイレントモードOFF
					se08_se();
				}
				setSoundState();
			}

		}else {
			console.log("【checkSilentMode】error", result);
			console.log("【checkSilentMode】result:", result.result);
		}

	} catch (error) {
		console.log('【checkSilentMode】error', error);
	}
};


//----------------------------------------
//お買物API：位置情報取得API << 12.位置情報取得API
//----------------------------------------

useEffect(() => {
	if(posFlg === true){
		//12.位置情報取得API
		// callAPI_12(sharedInfo.terminalCode);
		//お買物API：位置情報取得API << 12.位置情報取得API
		if(sharedInfo.terminalCode !== ""){
			okaimonoAPI_getDeviceLocation(sharedInfo.terminalCode);
		}
	}
}, [posFlg,sharedInfo.terminalCode]);

const okaimonoAPI_getDeviceLocation = async (tcode) => {
	try {
		console.log("----------------------------");
		console.log("【getDeviceLocation】お買物API：位置情報取得API call");
		const { callbackId, result } = await callOkaimonoAPI('getDeviceLocation');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【getDeviceLocation】success", result);
			console.log("【getDeviceLocation】result:", result.result);
			console.log("【getDeviceLocation】latitude:", result.latitude);
			// console.log("【getDeviceLocation】longtitude:", result.longtitude);
			console.log("【getDeviceLocation】longitude:", result.longitude);

			// let pos = result.latitude + ", " + result.longtitude;
			let pos = result.latitude + ", " + result.longitude;
			updategLocation(pos);
			console.log("sharedInfo.terminalCode: " + tcode);
			userinfoAPI(tcode);

			//scandit SDK 開始
			if(sdkStartFlg === false){
				setSdkStartFlg(true);
			}

		}else {
			console.log("【getDeviceLocation】error", result);
			console.log("【getDeviceLocation】result:", result.result);
			console.log("【getDeviceLocation】code:", result.error.code);
			console.log("【getDeviceLocation】message:", result.error.message);
			//本番
			setErrFlg(true);
			var error_msg = ";["+result.error.code+"];"+result.error.message+";;;";
			setErr([true, result.error.code, error_msg]);

			//テスト
			// var pos = "35.600458, 140.113616";
			// updategLocation(pos);
			// console.log("sharedInfo.terminalCode: " + tcode);
			// userinfoAPI(tcode);

			//scandit SDK 開始
			// if(sdkStartFlg === false){
			// 	setSdkStartFlg(true);
			// }
		}

	} catch (error) {
		console.log('【getDeviceLocation】error', error);
		setErrFlg(true);
		setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
};


//----------------------------------------
//お買物API：画面遷移API
//----------------------------------------

const okaimonoAPI_didScreenTransition = async (npage) => {
	try {
		console.log("----------------------------");
		console.log("【didScreenTransition】お買物API：画面遷移API call");

		const { callbackId, result } = await callOkaimonoAPI('didScreenTransition', { code: npage });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【didScreenTransition】success", result);
			console.log("【didScreenTransition】result:", result.result);

		}else {
			console.log("【didScreenTransition】error", result);
			console.log("【didScreenTransition】result:", result.result);
		}

	} catch (error) {
		console.log('【didScreenTransition】error', error);
	}
};


//----------------------------------------
//お買物API：ネイティブから呼び出し Native → MiniApp
//----------------------------------------

//お買物API：クローズ呼び出しAPI
window.callCloseRegigoApp = function (callbackId) {
	console.log(">> window.callCloseRegigoApp 実行");
	console.log("callbackId: " + callbackId);
	console.log("result: " + JSON.stringify({ result: "1" }, null, 2));
	//お買物API：データ保存API（買物データ削除
	okaimonoAPI_delShoppingData();

	const response = {
		callbackId,
		result: JSON.stringify({ result: "1" })
	};
	return JSON.stringify(response);
};

//代表レジ：精算確認APIコール
const [onSettleCheckSenyou, setOnSettleCheckSenyou] = useState(null);
//専用レジ：精算確認APIコール
const [onSettleCheckSelf, setOnSettleCheckSelf] = useState(null);

//お支払い完了通知API
window.callCheckPayment = function (callbackId) {
	console.log(">> window.callCheckPayment 実行");
	console.log("callbackId: " + callbackId);
	console.log("result: " + JSON.stringify({ result: "1" }, null, 2));

	if (page === "regi_senyou") { //代表レジ
		// RegiSenyouの精算確認APIコール
		if (onSettleCheckSenyou) {
			console.log("【callCheckPayment】代表レジ：onSettleCheckSenyou");
			onSettleCheckSenyou();
		}
	} else if (page === "regi_self") { //専用レジ
		// RegiSelfの精算確認APIコール
		if (onSettleCheckSelf) {
			console.log("【callCheckPayment】専用レジ：onSettleCheckSelf");
			onSettleCheckSelf();
		}
	} else {
		console.log("【callCheckPayment】代表レジ・専用レジ以外：ノーアクション");
	}

	const response = {
		callbackId,
		result: JSON.stringify({ result: "1" })
	};
	return JSON.stringify(response);
};

//お買物API：スキャン画面離脱通知API（スキャン画面終了API 25.12.08追加
window.callCloseScan = function (callbackId) {
	console.log(">> window.callCloseScan 実行");
	console.log("callbackId: " + callbackId);
	console.log("result: " + JSON.stringify({ result: "1" }, null, 2));

	// Scanページ表示中なら子コンポーネントに終了命令
	if (page === "scan") {
		if (barcodeScannerRef && barcodeScannerRef.current && barcodeScannerRef.current.appCloseScan) {
			console.log("【callCloseScan】scanページ：appCloseScan実行");
			barcodeScannerRef.current.appCloseScan();
		} else {
			console.log("【callCloseScan】scanページ：appCloseScan未登録");
		}
	} else {
		console.log("【callCloseScan】scanページ以外：ノーアクション");
	}

	const response = {
		callbackId,
		result: JSON.stringify({ result: "1" })
	};
	return JSON.stringify(response);
};


//----------------------------------------
//お買物API：データ保存API（買物データ削除
//----------------------------------------

const okaimonoAPI_delShoppingData = async () => {
	try {
		console.log("----------------------------");
		console.log("【saveTransactionData:shopping_data】お買物API：データ保存API call");
		const { callbackId, result } = await callOkaimonoAPI('saveTransactionData', { key: 'shopping_data', value: '' });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【saveTransactionData:shopping_data】success", result);
			console.log("【saveTransactionData:shopping_data】result:", result.result);
			//お買物API：クローズAPI
			okaimonoAPI_closeApp();
		}else {
			console.log("【saveTransactionData:shopping_data】error", result);
			console.log("【saveTransactionData:shopping_data】result:", result.result);
			//お買物API：クローズAPI
			okaimonoAPI_closeApp();
		}

	} catch (error) {
		console.log('【saveTransactionData:shopping_data】error', error);
		//お買物API：クローズAPI
		okaimonoAPI_closeApp();
	}
};


//----------------------------------------
//お買物API：アプリバージョン取得API（25.12.06追加
//----------------------------------------

//お買物アプリバージョン
const [appVersion, setAppVersion] = useState("12.5.0");

const okaimonoAPI_getAppVersion = async () => {
	try {
		console.log("----------------------------");
		console.log("【getAppVersion】お買物API：アプリバージョン取得API call");
		const { callbackId, result } = await callOkaimonoAPI('getAppVersion');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【getAppVersion】success", result);
			console.log("【getAppVersion】result:", result.result);
			console.log("【getAppVersion】version:", result.appVersion);

			//お買物アプリバージョン
			setAppVersion(result.appVersion);

		}else {
			console.log("【getAppVersion】error", result);
			console.log("【getAppVersion】result:", result.result);
			console.log("【getAppVersion】code:", result.error.code);
			console.log("【getAppVersion】message:", result.error.message);

			console.log("【getAppVersion】エラー時はデフォルトバージョンを使用：12.5.0");
			// setErrFlg(true);
			// var error_msg = ";["+result.error.code+"];"+result.error.message+";;;";
			// setErr([true, result.error.code, error_msg]);
		}

	} catch (error) {
		console.log('【getAppVersion】error', error);
		console.log("【getAppVersion】エラー時はデフォルトバージョンを使用：12.5.0");
		// setErrFlg(true);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
};


//----------------------------------------
//お買物API：新規取引開始通知API（26.02.19追加、26.06.17更新
//----------------------------------------

const okaimonoAPI_didNewTransaction = async (scode) => {
	try {
		console.log("----------------------------");
		console.log("【didNewTransaction】お買物API：新規取引開始通知API call");
		console.log("【didNewTransaction】shopCode:", scode);
		const { callbackId, result } = await callOkaimonoAPI('didNewTransaction', { shopCode: scode });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【didNewTransaction】success", result);
			console.log("【didNewTransaction】result:", result.result);

		}else {
			console.log("【didNewTransaction】error", result);
			console.log("【didNewTransaction】result:", result.result);
			console.log("【didNewTransaction】code:", result.error.code);
			console.log("【didNewTransaction】message:", result.error.message);

			console.log("【didNewTransaction】エラー時はなにもせず終了");
			// setErrFlg(true);
			// var error_msg = ";["+result.error.code+"];"+result.error.message+";;;";
			// setErr([true, result.error.code, error_msg]);
		}

	} catch (error) {
		console.log('【didNewTransaction】error', error);
		console.log("【didNewTransaction】エラー時はなにもせず終了");
		// setErrFlg(true);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
};


//----------------------------------------
//お買物API：取引情報通知API（26.02.19追加
//----------------------------------------

const okaimonoAPI_notifyTransactionData = async (rtime, rno, scode) => {
	try {
		console.log("----------------------------");
		console.log("【notifyTransactionData】お買物API：取引情報通知API call");
		console.log("【notifyTransactionData】recordedTime:", rtime);
		console.log("【notifyTransactionData】registerNo:", rno);
		console.log("【notifyTransactionData】shopCode:", scode);
		const { callbackId, result } = await callOkaimonoAPI('notifyTransactionData', { recordedTime: rtime, registerNo: rno, shopCode: scode });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【notifyTransactionData】success", result);
			console.log("【notifyTransactionData】result:", result.result);

		}else {
			console.log("【notifyTransactionData】error", result);
			console.log("【notifyTransactionData】result:", result.result);
			console.log("【notifyTransactionData】code:", result.error.code);
			console.log("【notifyTransactionData】message:", result.error.message);

			console.log("【notifyTransactionData】エラー時はなにもせず終了");
			// setErrFlg(true);
			// var error_msg = ";["+result.error.code+"];"+result.error.message+";;;";
			// setErr([true, result.error.code, error_msg]);
		}

	} catch (error) {
		console.log('【notifyTransactionData】error', error);
		console.log("【notifyTransactionData】エラー時はなにもせず終了");
		// setErrFlg(true);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
};


//----------------------------------------
//お買物API：レジ転送情報通知API（26.06.17追加
//----------------------------------------

const okaimonoAPI_didTransferTransaction = async (icount, taxinp, taxexp, rtype) => {
	try {
		console.log("----------------------------");
		console.log("【didTransferTransaction】お買物API：レジ転送情報通知API call");
		console.log("【didTransferTransaction】itemCount:", icount);
		console.log("【didTransferTransaction】taxIncludedPrice:", taxinp);
		console.log("【didTransferTransaction】taxExcludedPrice:", taxexp);
		console.log("【didTransferTransaction】registerType:", rtype);
		const { callbackId, result } = await callOkaimonoAPI('didTransferTransaction', { itemCount: icount, taxIncludedPrice: taxinp, taxExcludedPrice: taxexp, registerType: rtype });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【didTransferTransaction】success", result);
			console.log("【didTransferTransaction】result:", result.result);

		}else {
			console.log("【didTransferTransaction】error", result);
			console.log("【didTransferTransaction】result:", result.result);
			console.log("【didTransferTransaction】code:", result.error.code);
			console.log("【didTransferTransaction】message:", result.error.message);

			console.log("【didTransferTransaction】エラー時はなにもせず終了");
			// setErrFlg(true);
			// var error_msg = ";["+result.error.code+"];"+result.error.message+";;;";
			// setErr([true, result.error.code, error_msg]);
		}

	} catch (error) {
		console.log('【didTransferTransaction】error', error);
		console.log("【didTransferTransaction】エラー時はなにもせず終了");
		// setErrFlg(true);
		// setErr([true,`000`,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
};


//----------------------------------------
//お買物アプリ：OS判定＆iOSノッチデバイス判定（ホームボタン判定
//----------------------------------------

//OS判定（true：iOS、false：Android
const [isIOS, setIsIOS] = useState(false);
//iOSホームボタンの有無
const [isIphoneHomeButton, setIsIphoneHomeButton] = useState(false);

useEffect(() => {
	const ua = navigator.userAgent.toLowerCase();
	const isIOS = /iphone|ipad|ipod/.test(ua);
	const isAndroid = ua.includes("android");

	const getIphoneHomeButtonStatus = () => {
		const w = window.screen.width;
		const h = window.screen.height;

		// ホームボタンありと判定されるiPhoneの画面サイズ（iPhone6以降 + SEシリーズ）
		const homeButtonModels = [
			{ width: 375, height: 667 }, // iPhone 6, 6s, 7, 8, SE2, SE3
			{ width: 320, height: 568 }  // iPhone SE1
		];

		const matches = homeButtonModels.some(d =>
			(d.width === w && d.height === h) || (d.width === h && d.height === w)
		);

		if(matches){
			//ホームボタンあり
			setIsIphoneHomeButton(true);
		}else{
			//ホームボタンなし
			setIsIphoneHomeButton(false);
		}

		return matches
			? "iPhone (ホームボタンあり)"
			: "iPhone (ホームボタンなし)";
	};

	console.log("OS:", isIOS ? "iOS" : isAndroid ? "Android" : "Other");

	if (isIOS) {
		//iOS
		setIsIOS(true);
		console.log(getIphoneHomeButtonStatus());
	}
}, []);


//----------------------------------------
//お買物API：クローズAPI << 22.クローズAPIxx
//----------------------------------------

const okaimonoAPI_closeApp = async () => {
	try {
		console.log("----------------------------");
		console.log("【closeRegigoApp】お買物API：クローズAPI call");
		const { callbackId, result } = await callOkaimonoAPI('closeRegigoApp');

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【closeRegigoApp】success", result);
			console.log("【closeRegigoApp】result:", result.result);

		}else {
			console.log("【closeRegigoApp】error", result);
			console.log("【closeRegigoApp】result:", result.result);
		}

	} catch (error) {
		console.log('【closeRegigoApp】error', error);
	}
};


return (
<>
<GPSStorelist.Provider value={GPSStorelistData}>
<ShoppingStart.Provider value={shoppingStData}>
{/* <ShoppingStart.Provider value={shoppingStartData}> */}
	<div className={`loadingBox01`}>
		<div className={`loadingBox01_img`}>
			<img src="/images/loading01.svg" alt="" width="55" height="55"/>
		</div>
	</div>
	<div className={`loadingBox01_cover`}></div>
	<div id="fcover" className={`first_cover`}></div>
	<header id="header" className="l_header">
		{
			(() => {
				if (page === "faq" || page === "policy" || page === "help" || page === "regi_meisai") {
				return(
					<button className={`header_btn header_menuBtn is_open`} onClick={onPageBack}>
						<span><img src="/images/icn_back01_black.svg" alt="" width="24" height="24"/></span>
						<img src="/images/btn_menu01.svg" alt="" width="24" height="24"/>
					</button>
				)
				} else if (page === "kuji_list") {
				return(
					<button className={`header_btn header_menuBtn is_open`} onClick={closeKujiList}>
						<span><img src="/images/icn_back01_black.svg" alt="" width="24" height="24"/></span>
						<img src="/images/btn_menu01.svg" alt="" width="24" height="24"/>
					</button>
				)
				} else if (page === "policy_check") {
				return(
					<button className={`header_btn header_menuBtn is_hide`}></button>
				)
				} else {
				return (
					<button className={`header_btn header_menuBtn ${gnav ? 'is_open' : ''}`} onClick={onMenuBtn}>
						<span><img src="/images/icn_back01_black.svg" alt="" width="24" height="24"/></span>
						<img src="/images/btn_menu01.svg" alt="" width="24" height="24"/>
					</button>
				)
				}
			})()
		}
		{
			(() => {
				if (page === "home") {
				return(
					// <div className="header_logo is_hide">
					// 	<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24" loading="lazy"/></span>
					// </div>
					<div className="header_titBox">
						<div className="header_logo is_hide">
							<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
						</div>
						<p className="header_tit is_hide">よくあるご質問</p>
					</div>
				)
				} else if (page === "faq") {
				return(
					// <div className="header_logo is_hide">
					// 	<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24" loading="lazy"/></span>
					// </div>
					<div className="header_titBox">
						<div className="header_logo is_hide">
							<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
						</div>
						<p className="header_tit">よくあるご質問</p>
					</div>
				)
				} else if (page === "policy" || page === "policy_check") {
					return(
						<div className="header_titBox">
							<div className="header_logo is_hide">
								<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
							</div>
							<p className="header_tit">ご利用規約</p>
						</div>
					)
				} else if (page === "help") {
					return(
						<div className="header_titBox">
							<div className="header_logo is_hide">
								<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
							</div>
							<p className="header_tit">ご利用方法</p>
						</div>
					)
				} else if (page === "kuji_list") {
					return(
						<div className="header_titBox">
							<div className="header_logo is_hide">
								<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
							</div>
							<p className="header_tit">くじ抽選結果</p>
						</div>
					)
				} else if (page === "regi_meisai") {
					return(
						<div className="header_titBox">
							<div className="header_logo is_hide">
								<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
							</div>
							<p className="header_tit">本日のお買い物</p>
						</div>
					)
				} else {
				return (
					// <div className="header_logo">
					// 	<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24" loading="lazy"/></span>
					// </div>
					<div className="header_titBox">
						<div className="header_logo is_hide">
							<span className={`${gnav ? 'is_hide' : ''}`}><img src="/images/logo_regigo01.svg" alt="レジゴー" width="125" height="24"/></span>
						</div>
						<p className="header_tit is_hide">よくあるご質問</p>
					</div>
				)
				}
			})()
		}
		{
			(() => {
				if (page === "faq" || page === "policy" || page === "help" || page === "kuji_list" || page === "regi_meisai") {
				return(
					<button className={`header_btn header_closeBtn is_hide`} onClick={closeApp}>
						<img src="/images/btn_close01.svg" alt="" width="24" height="24"/>
					</button>
				)
				} else {
				return (
					<button className={`header_btn header_closeBtn ${gnav ? 'is_hide' : ''}`} onClick={closeApp}>
						<img src="/images/btn_close01.svg" alt="" width="24" height="24"/>
					</button>
				)
				}
			})()
		}
	</header>
	{
		(() => {
			if (page === "policy_check" || page === "home" || page === "intro" || page === "attention" || page === "shopping" || page === "scan" || page === "qrscan" || page === "regi_select" || page === "front_check" || page === "regi_senyou" || page === "regi_senyou_comp" || page === "regi_self" || page === "regi_self_comp" || page === "regi_yujin" || page === "regi_meisai" || page === "faq" || page === "policy" || page === "help" || page === "kuji_lottery" || page === "kuji_list" || page === "error_32" || page === "error_35" || page === "error_version") { //お気に入り店舗スタート画面/ウォークスルー/お買物ホーム
				return (
	<div id="contents" className="container l_contents">
		<TransitionGroup component="div" className="App">
		<CSSTransition
			nodeRef={nodeRef}
			key={currentComponent}
			timeout={timeout}
			classNames="slider"
		>
			<div ref={nodeRef} className={`${currentComponent} ${getDirection(currentComponent)} ${getMoveDir()}`}>
				{renderComponent()}
			</div>
		</CSSTransition>
		</TransitionGroup>
						</div>
					)
				}
			})()
		}

		<PayModal showPayModal={showPayModal} setShowPayModal={setShowPayModal} page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} timeoutCountFlg={timeoutCountFlg} setTimeoutCountFlg={setTimeoutCountFlg} timeoutCount={timeoutCount} setTimeoutCount={setTimeoutCount} scanActive={scanActive} setScanActive={setScanActive} soundState={soundState} setSoundState={setSoundState} otb={otb} setOtb={setOtb} otbErr={otbErr} setOtbErr={setOtbErr} isFetchingOtb={isFetchingOtb} setIsFetchingOtb={setIsFetchingOtb} isWaitingForOtb={isWaitingForOtb} setIsWaitingForOtb={setIsWaitingForOtb} isButtonDisabled={isButtonDisabled} setIsButtonDisabled={setIsButtonDisabled} isKaikeiButtonDisabled={isKaikeiButtonDisabled} setIsKaikeiButtonDisabled={setIsKaikeiButtonDisabled} isScanButtonDisabled={isScanButtonDisabled} setIsScanButtonDisabled={setIsScanButtonDisabled} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>

		<Modal page={page} setPage={setPage} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} scanFlg={scanFlg} setScanFlg={setScanFlg} closeStore={closeStore} setCloseStore={setCloseStore} activeStore={activeStore} setActiveStore={setActiveStore} settlecheckFlg={settlecheckFlg} setSettlecheckFlg={setSettlecheckFlg} regiType={regiType} setRegiType={setRegiType} recoveryChoice={recoveryChoice} setRecoveryChoice={setRecoveryChoice} shoppingData={shoppingData} soundState={soundState} setSoundState={setSoundState} frontCheckRetry={frontCheckRetry} setFrontCheckRetry={setFrontCheckRetry} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition} gnav={gnav} okaimonoAPI_didNewTransaction={okaimonoAPI_didNewTransaction}/>

		<ItemDelete delModal={delModal} setDelModal={setDelModal} page={page} setPage={setPage} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>

		<GetAttention delModal={delModal} setDelModal={setDelModal} page={page} setPage={setPage} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState} getAtState={getAtState} setGetAtState={setGetAtState} getAtChange={getAtChange} setGetAtChange={setGetAtChange} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>

		<NoBarcode showNoBarcode={showNoBarcode} setShowNoBarcode={setShowNoBarcode} shoppingData={shoppingData} setShoppingData={setShoppingData} showItemNum={showItemNum} setShowItemNum={setShowItemNum} shoppingStData={shoppingStData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} keypluFlg={keypluFlg} setKeypluFlg={setKeypluFlg} keypluCount={keypluCount} setKeypluCount={setKeypluCount} setSoundState={setSoundState} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition}/>

		<ItemNum showItemNum={showItemNum} setShowItemNum={setShowItemNum} shoppingData={shoppingData} setShoppingData={setShoppingData} errFlg={errFlg} setErrFlg={setErrFlg} err={err} setErr={setErr} soundState={soundState} setSoundState={setSoundState} getAtChange={getAtChange} setGetAtChange={setGetAtChange} okaimonoAPI_didScreenTransition={okaimonoAPI_didScreenTransition} getAtState={getAtState}/>

		<div id="globalNav" className={`${styles.l_globalNav} ${gnav ? styles.is_open : ''}`}>
			<div className={styles.l_globalNav_wrap}>
				<div className={styles.l_globalNav_in}>
					<div className={styles.l_globalNav_top}>
						<p className={styles.globalNav_txt}>レジゴーについて</p>
						<nav className={styles.globalNav}>
							<button onClick={goHelp} className={`${styles.globalNav_btn} custom_btn`}>
							<span className={styles.globalNav_btn_ar}>
								<img src="/images/icn_ar01_black.svg" alt="" width="16" height="16" />
							</span>
						ヘルプ</button>
							{/* <button onClick={goFaq} className={`${styles.globalNav_btn} custom_btn`}>
							<span className={styles.globalNav_btn_ar}>
								<img src="/images/icn_ar01_black.svg" alt="" width="16" height="16" />
							</span>
						よくあるご質問・お問い合わせ</button> */}
							<button onClick={goPolicy} className={`${styles.globalNav_btn} custom_btn`}>
							<span className={styles.globalNav_btn_ar}>
								<img src="/images/icn_ar01_black.svg" alt="" width="16" height="16" />
							</span>
						ご利用規約</button>
						</nav>
					</div>
					<div className={styles.l_globalNav_bottom}>
						<button className={`${styles.globalNav_closeBtn} custom_btn`} onClick={closeApp}><span>お買い物を中止する</span></button>
						{/* <p className={styles.globalNav_version}>Version 0.00-0</p> */}
					</div>

				</div>
			</div>
		</div>
		<div className={styles.globalNav_bg} onClick={onMenuBtn}></div>
		</ShoppingStart.Provider>
		</GPSStorelist.Provider>
	</>
	)
}

export default App;
